export default {
    VIETNAMESE: "Tiếng Việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ",
    SYNC: "Đồng bộ",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "Vui lòng chọn khoảng ngày không quá 6 tháng",
    CHAIN_DASHBOARD_INFO: "Chuỗi",
    CHAIN_DASHBOARD: "Bảng điều khiển chuỗi",
    BOOKING_DASHBOARD: "Bảng điều khiển đặt phòng",
    USE_HOTEL: "Truy cập",
    CANCEL_SUCCESS: "Cập nhật thành công",
    BOOKING_PAID: "Đã thanh toán",
    BOOKING_CANCELED: "Đặt phòng không thể hủy, vui lòng xem lại trạng thái",
    LOCATION_IS_NOT_EXIST: "Quận huyện không tồn tại",
    ROOM_AVAILS_INCORRECT: "Giá trị phòng trống không được lớn hơn giá trị tổng số phòng được khai báo",
    CANCLE_FAILE: "Hủy thất bại",
    DELETE_FAILE: "Xóa thất bại",
    GROUP_USED: "Nhóm người dùng đang được sử dụng",
    PROMOTION_NULL: "Khuyến mại không tồn tại",
    TRANSDATE_INCORRECT: "Ngày thanh toán phải nằm trong khoảng ngày đặt và ngày trả phòng",
    AMOUNT_INCORRECT: "Số tiền thanh toán không đúng",
    LOCATION_NOT_EXIST: "Địa điểm không tồn tại",
    UPDATE_SUCCESS: "Cập nhật thành công",
    UPDATE_CUCCESS: "Cập nhật thành công",
    UPDATE_FAILED: "Cập nhật thất bại",
    DELETE_SUCCESS: "Xóa thành công",
    DELETE_FAILED: "Xóa thất bại",
    CREATE_SUCCESS: "Thêm mới thành công",
    CREATE_FAILED: "Thêm mới thất bại",
    UPLOAD_SUCCESS: "Cập nhật thành công",
    UPLOAD_FAILED: "Tải lên thất bại",
    REGISTER_SUCCESS: "Đăng ký thành công",
    PROMOTIONS_ARE_BEING_USED: "Khuyến mại đang được sử dụng",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "Khuyến mại không được áp dụng cho khách sạn",
    COUNPON_EXIST: "Mã khuyến mại đã tồn tại",
    USER_IS_EXIST: "Tài khoản đăng nhập đã tồn tại",
    EMAIL_USER_IS_EXIST: "Email người dùng đã tồn tại",
    EMAIL_HOTEL_IS_EXIST: "Email khách sạn đã tồn tại",
    USER_NAME_OR_EMAIL_IS_EXISTED: "Tên đăng nhập hoặc email người dùng đã tồn tại",
    ACCOUNT_IS_TAKEN: "Tên đăng nhập đã tồn tại",
    CANNOT_FIND_SOURCE: "Không tìm được ảnh",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "Dung lượng ảnh được phép upload tối đa:",
    FILE_CAPACITY_NOT_BIGGER_THAN: "Dung lượng file được phép upload tối đa:",
    IMAGE_SIZE_NOT_BIGGER_THAN: "Ảnh có kích thước tối thiểu",
    INVALID_IMAGE_FORMAT: "Định dạng ảnh không hợp lệ",
    INVALID_FILE_FORMAT: "Định dạng tệp tin không hợp lệ",
    DELETE_FAIL: "Xóa ảnh thất bại",
    IMAGE_MAIN_EMPTY: "Ảnh chính không tìm thấy",
    ROOM_EMPTY: "Không tìm thấy phòng",
    ROOM_IS_SELECTING: "Phòng đang được sử dụng",
    NOT_SELECTED_PROMOTION: "Không có gói khuyến mại nào được chọn",
    MISSING_FIELD: "VUI LÒNG NHẬP ĐẦY ĐỦ THÔNG TIN CẦN THIẾT",
    CONFIRM_DELETE_PHOTOS: "Xác nhận xóa ảnh",
    MAIN_IMAGES_MUST_EXIST: "Phải có ảnh chính trong danh mục",
    CONFIRM_DELETE_POLICY: "Xác nhận xóa chính sách",
    CONFIRM_DELETE_SALE_PACKAGE: "Xác nhận xóa chính sách giá này",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "Xác nhận xóa gói khuyễn mại này",
    CONFIRM_DELETE_ROOM: "Xác nhận xóa phòng",
    SETTING_GATEWAY_EMPTY: "Cấu hình cổng thanh toán không tồn tại",
    DEPOSIT_COMPARE_PAYMENT: "Hạn thanh toán đặt phòng không được lớn hơn hạn thanh toán đặt cọc",
    UPLOAD_EXPIRED: "Hết hạn đăng tải",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "Chưa chọn phương thức thanh toán",
    TIP_MAIN_IMAGE: "Ảnh đại diện khách sạn là ảnh đầu tiên. Kéo - thả các ảnh để thay đổi thứ tự hiển thị",
    TIP_MAIN_ROOM_IMAGE: "Ảnh đại diện phòng là ảnh đầu tiên. Kéo - thả các ảnh để thay đổi thứ tự hiển thị",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "Tổng số khách áp dụng của gói không được lớn hơn tổng số khách ở tối đa trong phòng",
    USER_NOT_RIGHT: "Không có quyền",
    USER_IS_EXIST: "Tài khoản đã tồn tại",
    USER_NOT_EXIST: "Không tồn tại tài khoản",
    EMAI_IS_EXIST: "Email đã tồn tại",
    ACTIVE_SUCCESS: "Kích hoạt thành công",
    DEACTIVE_SUCCESS: "Hủy liên kết thành công",
    FIELD_NUMBER_FORMAT: "Chỉ cho phép nhập ký tự số, không chứa khoảng trắng",
    FIELD_POSITIVE_FORMAT: "Chỉ cho phép nhập số nguyên dương, không chứa khoảng trắng",
    FIELD_DISTANCE_FORMAT: "Chỉ cho phép nhập ký tự số, dấu chấm (.), không chứa khoảng trắng",
    TODAY: "Hôm nay",
    YESTERDAY: "Hôm qua",
    TOMORROW: "Ngày mai",
    LOGIN_FAILED: "Đăng nhập thất bại",
    HAS_NO_DATA: "Không có dữ liệu",
    CHAIN_NAME_EMPTY: "Chưa tạo chuỗi",
    USER_IS_NOT_EXIT: "Người dùng không tồn tại",
    USER_IS_NOT_EXIST: "Người dùng không tồn tại",
    HOTEL_WAS_IN_CHAIN: "Khách sạn đã có trong chuỗi",
    FEEDBACK_SUCCESS: "Phản hồi thành công",
    AGENT_STOP_CONNECT: "Đại lý ngừng liên kết",
    _VALIDATE: {
        REQUIRED: "Vui lòng nhập đầy đủ thông tin cần thiết",
        EMAIL_FORMAT: "Vui lòng kiểm tra lại định dạng email",
        MIN_LENGTH: "Giá trị nhập vào phải nhiều hơn {minLength} kí tự",
        MAX_LENGTH: "Giá trị nhập vào phải ít hơn {maxLength} kí tự",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "Chọn ít nhất một chuỗi hoặc khách sạn cho người dùng"
    },
    DESCRIPTION_INFO: "Thông tin mô tả",
    REQUIRED: "*",
    SELECT_ALL: "Chọn tất cả",
    IMAGES: "Hình ảnh",
    HOTEL_PHOTO: "Hình ảnh khách sạn",
    LIBRARY: "Thư viện",
    ADD_NEW: "Thêm",
    AND: "và",
    BACK: "Quay lại",
    SAVE: "Lưu",
    CONFIRM: "Xác nhận",
    EDIT: "Sửa",
    DELETE: "Xóa",
    COPY: "Sao chép",
    POLICY: "chính sách",
    ALWAYS: "Luôn luôn",
    IN_PERIOD: "Trong khoảng",
    GENERAL_SETTING: "Cấu hình chung",
    PAYMENT_POLICY: "Chính sách thanh toán",
    CANCELATION_POLICY: "Chính sách hủy đặt phòng",
    PAY_GATE: "Cổng thanh toán",
    WARNING_METHOD: "Phương thức cảnh báo",
    ALERT_RECEIVING_METHOD: "Phương thức nhận cảnh báo",
    SELECT_WARNING_METHOD: "Chọn phương thức nhận cảnh báo",
    WARNING_QTY_ROOM: "Cảnh báo khi số lượng phòng đạt ngưỡng",
    SETTING_WARNING_ROOM: "Gửi cảnh báo khi số lượng phòng đạt ngưỡng",
    SEND_WARNING_ANY_ROOM: "Gửi cảnh báo khi số phòng trống của bất kì loại phòng nào nhỏ hơn ngưỡng cài đặt",
    SEND_WARNING_ROOM: "Gửi cảnh báo khi một trong số các loại phòng có số phòng nhỏ hơn ngưỡng cài đặt",
    SETTING_WARNING_ROOM: "Gửi cảnh báo khi số lượng phòng đạt ngưỡng",
    SEND_WARNING_ANY_ROOM: "Gửi cảnh báo khi số phòng trống của bất kì loại phòng nào nhỏ hơn ngưỡng cài đặt",
    SEND_WARNING_ROOM: "Gửi cảnh báo khi một trong số các loại phòng có số phòng nhỏ hơn ngưỡng cài đặt",
    QTY_ROOM_LESS_THAN: "Số lượng phòng nhỏ hơn",
    HOTEL_WARNING: "Phương thức cảnh báo",
    SETTING_AT_LEAST_1_ROOM: "Vui lòng chọn ít nhất 1 loại phòng để thực hiện cài đặt ngưỡng cảnh báo",
    HOTEL_WARNING: "Phương thức cảnh báo",
    SETTING_AT_LEAST_1_ROOM: "Vui lòng chọn ít nhất 1 loại phòng để thực hiện cài đặt ngưỡng cảnh báo",
    REGISTER_INFO: "Thông tin đăng ký",
    EXTENSION: "Tiện ích",
    NEARBY_PLACE: "Địa điểm lân cận",
    HOTEL_CHAIN: "Chuỗi khách sạn",
    HOTEL_REGISTER_INFO: "Thông tin đăng ký khách sạn",
    HOTEL_CODE: "Mã khách sạn",
    STAR_RATING: "Hạng sao",
    HOTEL_LOGO: "Logo khách sạn",
    CONTACT_PHONE: "Số điện thoại liên hệ",
    HOTEL_TYPE: "Loại hình kinh doanh",
    COUNTRY: "Quốc gia",
    CITY: "Tỉnh / Thành phố",
    DISTRICT: "Phường / Xã / Đặc khu",
    WARD: "Khu vực",
    HOTEL_NAME: "Tên khách sạn",
    ADDRESS: "Địa chỉ",
    MAP_LOCATION: "Vị trí trên bản đồ",
    LONGITUDE: "Kinh độ",
    LATITUDE: "Vĩ độ",
    DASHBOARD: "Màn hình chính",
    MANAGE: "Quản lý",
    BOOK_ROOM: "Đặt phòng",
    ROOM_SALE: "Bán phòng",
    ROOM_AVAILABLE_AND_PRICE: "Phòng trống và giá",
    SALE_AND_PROMOTION_PACKAGES: "Chính sách giá và khuyến mại",
    SETTING: "Cài đặt",
    ACCOUNT_INFO: "Thông tin tài khoản",
    ACCOUNT_SETTING: "Tài khoản cá nhân",
    USER_MANAGE: "Quản lý người dùng",
    CONTRACT: "Hợp đồng",
    HOTEL_INFOMATION: "Thông tin khách sạn",
    GENERAL_INFO: "Thông tin chung",
    TYPE_ROOM: "Thông tin loại phòng",
    HOTEL_CONFIG: "Cấu hình khách sạn",
    GALLERY_MANAGER: "Quản lý thư viện ảnh",
    TRAVEL_AGENT: "Đại lý du lịch",
    AGENT_LIST: "Danh sách đại lý",
    UNLINKED_LIST: "Đại lý ngừng hợp tác",
    ACTIVITY_DAIRY: "Nhật ký hoạt động",
    ACTIVITY_DIARY_UPDATE_BULK: "Nhật ký cập nhật giá",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "Nhật ký cập nhật phòng trống",
    SUPPORT: "Hỗ trợ",
    INSTRUCTION_DOCUMENT: "Tài liệu hướng dẫn sử dụng",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "Tích hợp Website",
    COPYED: "Đã sao chép",
    VIEW_DEMO: "Xem trang Booking Engine",
    HOTLINE: "Hotline",
    BOOKING_LIST: "Danh sách đặt phòng",
    REQUEST_BOOKING_LIST: "Danh sách yêu cầu đặt phòng",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "Giao dịch thu chi",
    PREVIEW_ON_BE: "Xem trang đặt phòng",
    PREVIEW_ON_TA: "Xem trang TA",
    SALE_CHANNEL: "Kênh bán",
    CHANNEL_GROUP: "Nhóm kênh bán",
    SUNDAY: "Chủ nhật",
    MONDAY: "Thứ 2",
    TUESDAY: "Thứ 3",
    WEDNESDAY: "Thứ 4",
    THURSDAY: "Thứ 5",
    FRIDAY: "Thứ 6",
    SATURDAY: "Thứ 7",
    _DATE_RANGE: {
        SUNDAY: "CN",
        MONDAY: "T2",
        TUESDAY: "T3",
        WEDNESDAY: "T4",
        THURSDAY: "T5",
        FRIDAY: "T6",
        SATURDAY: "T7",
        JAN: "Tháng 1",
        FEB: "Tháng 2",
        MAR: "Tháng 3",
        APR: "Tháng 4",
        MAY: "Tháng 5",
        JUN: "Tháng 6",
        JUL: "Tháng 7",
        AUG: "Tháng 8",
        SEP: "Tháng 9",
        OTC: "Tháng 10",
        NOV: "Tháng 11",
        DEC: "Tháng 12"
    },
    _ROLES: {
        CHAIN: "Chuỗi",
        BOOKING_CHAIN: "Đặt phòng trong Chuỗi",
        CHAIN_LIST: "Danh sách chuỗi",
        USER_MANAGEMENT: "Quản lý người dùng",
        DASHBOARD: "Màn hình chính",
        MANAGE: "Quản lý",
        BOOKING_HOTEL: "Đặt phòng trong khách sạn",
        ROOM_SALE: "Bán phòng",
        ROOM_SALE_MANAGEMENT: "Quản lý bán phòng",
        SALE_PACKAGE_MANAGEMENT: "Quản lý chính sách giá",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "Cài đặt",
        ACCOUNT_INFOMATION: "Thông tin tài khoản",
        PERSONAL_ACCOUNT: "Thông tin cá nhân",
        GENERAL_INFORMATION: "Thông tin chung",
        HOTEL_AMENITY: "Quản lý tiện ích",
        HOTEL_IMAGE: "Quản lý ảnh",
        NEARBY_PLACE: "Quản lý địa điểm lân cận",
        ROOM_TYPE: "Thông tin loại phòng",
        ROOM_INFORMATION: "Quản lý thông tin phòng",
        ROOM_AMENITY: "Quản lý tiện ích phòng",
        ROOM_IMAGE: "Quản lý ảnh phòng",
        HOTEL_CONFIGURATION: "Cấu hình khách sạn",
        GENERAL_CONFIGURATION: "Cấu hình thông tin chung",
        PAYMENT_POLICY: "Cấu hình chính sách thanh toán",
        CANCELLATION_POLICY: "Cấu hình chính sách hủy",
        IMAGE_LIBRARY: "Cấu hình thư viện ảnh",
        HISTORY_LOG: "Truy cập lịch sử hệ thống",
        PAYMENT_METHOD: "Phương thức thanh toán",
        BOOKING_ENGINE: "Công cụ đặt phòng",
        BOOKING_ENGINE_CONFIG: "Cấu hình",
        HOTEL_EMAIL: "Email",
        HOTEL_BOOKING_CONFIRM: "Xác nhận đặt phòng",
        HOTEL_SERVICE: "Dịch vụ",
        HOTEL_PROMOTION: "Khuyến mại",
        HOTEL_INFORMATION: "Thông tin khách sạn",
        BOOKING_MANAGEMENT: "Đặt phòng",
        SYNC_MANAGEMENT: "Quản lý đồng bộ",
        HEADER_FOOTER: "Giao diện",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "Kênh bán",
        SU_MAPPING: "Ánh xạ",
        HOTEL_BOOKING_REPOST: "Repost booking",
        CHAIN_SERVICE: "Dịch vụ",
        CHAIN_ROOM_TYPE: "Thông tin loại phòng",
        CHAIN_RATE_PLAN: "Gói bán phòng",
        CHAIN_TRAVEL_AGENT: "Thông tin công ty, đại lý",
        HOTEL_TRAVEL_AGENT: "Thông tin công ty, đại lý",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "Quản lý doanh thu",
        DYNAMIC_PRICING: "Giá linh hoạt",
        MASTER_RATE: "Giá kế thừa",
        BE_MANAGEMENT: "ezBe",
        PACKAGE_MANAGEMENT: "Bán gói",
        PACKAGE_ITEM: "Dịch vụ gói",
        PACKAGE_DEAL: "Gói bán",
        HOTEL_BOOKING_GROUP: "Danh sách đặt phòng đoàn",
        BOOKING_UNMAP_HOTEL: "Danh sách đặt phòng chưa gán",
        HOTEL_DASHBOARD_IGNORE_TASK: "Bỏ qua",
        HOTEL_DASHBOARD_REUPDATE_TASK: "Cập nhật lại",
        HOTEL_BOOKING_UNMAP_REPOST: "Repost booking",
        CHAIN_ROOM_UPDATE_QUANTITY: "Cập nhật số lượng phòng",
        HOTEL_DASHBOARD: "Màn hình chính",
        ROOM_UPDATE_QUANTITY: "Cập nhật số lượng phòng",
        DYNAMIC_RESTRICTION: "Hạn chế linh hoạt",
        DYNAMIC_ROOM_SALE: "Bán phòng linh hoạt",
        DYNAMIC_CONFIGURATION: "Cấu hình",
        CHAIN_BOOKING_REPOST: "Repost booking",
        INVENTORY: "Phòng trống",
        RATE: "Giá",
        RESTRICTION: "Hạn chế",
        STOP_SELL_LIMIT: "Giới hạn bán",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "Kênh bán",
        CHANNEX_MAPPING: "Ánh xạ",
        WARNING_METHOD: "Phương thức cảnh báo",
        TRAVELOKA_MANAGEMENT: "ezCms Traveloka",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING : "Ánh xạ",
        STAAH_CONNECTION: "Kênh bán",
    },
    _PAYGATE: {
        PAYMENT_THROUGH: "Thanh toán qua",
        PAYMENT_METHOD: "Phương thức thanh toán",
        ONLINE_PAYMENT_GATEWAY: "Cổng thanh toán trực tuyến",
        CONFIGURATION: "Cấu hình",
        CONFIG_PAYMENT_GATE: "Cấu hình cổng thanh toán",
        HOTEL: "Khách sạn",
        TRANSFER_PAYMENT: "Thanh toán chuyển khoản",
        ONLINE_PAYMENT: "Thanh toán trực tuyến",
        PAYMENT_TYPE_EMPTY: "Không tồn tại loại thanh toán qua",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "Phương thức thanh toán không được chọn",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "Cổng thanh toán trực tuyến không được chọn",
        CASH: "Thanh toán tiền mặt",
        DEBT: "Thanh toán công nợ",
        PAYMENT_CARD: "Thẻ thanh toán"
    },
    _SUPPORT: {
        TITLE: "Hướng dẫn tích hợp Booking Engine vào website"
    },
    _DASHBOARD: {
        TITLE: "Bảng điều khiển",
        IN_MONTH_REVENUE: "Doanh thu trong tháng (VND)",
        SEVEN_DAY_REVENUE: "Doanh thu 7 ngày gần nhất (VND)",
        COLLECTION: "Khoản phải thu (VND)",
        ROOM_FILLING_RATE: "Tỉ lệ lấp đầy phòng trong tháng",
        BOOKING_EMPTY: "Các đặt phòng mới sẽ xuất hiện tại đây",
        BOOKING_NOT_PAYMENT: "Booking chưa thanh toán",
        BOOKING_PART_PAYMENT: "Booking đã thanh toán một phần",
        BOOKING_CANCELED: "Booking bị hủy bởi khách hàng",
        GO_TO_BOOKING_LIST: "Xem đầy đủ danh sách đặt phòng",
        STATUS: "Tình trạng",
        HOTEL_STATUS: "Thông tin khách sạn",
        CONTRACT: "Hợp đồng",
        DEBT: "Công nợ",
        SYNC_PMS: "Đồng bộ PMS",
        MISSING_INFO: {
            SYNC_OTA: "Đồng bộ OTA",
            SYNC_OTA_SUB_TITLE: "Đồng bộ tối thiểu 1 kênh OTA",
            RESTRICTION: "Khai báo hạn chế",
            RESTRICTION_SUB_TITLE: "Khai báo tối thiểu một hạn chế",
            RATE_PLAN: "Khai báo giá, số lượng phòng trống",
            RATE_PLAN_SUB_TITLE: "Khai báo giá tối thiểu cho 1 kênh và số lượng phòng trống",
            TITLE: "Hoàn thiện các thông tin bắt buộc",
            HOTEL_INFO: "Thông tin khách sạn",
            HOTEL_INFO_SUB_TITLE: "Điền đầy đủ các trường bắt buộc",
            ROOM_TYPE: "Thông tin loại phòng",
            ROOM_TYPE_SUB_TITLE: "Khai báo tối thiểu 1 loại phòng",
            HOTEL_IMAGE: "Hình ảnh khách sạn",
            HOTEL_IMAGE_SUB_TITLE: "Tải lên tối thiểu 1 hình ảnh",
            ROOM_PLAN: "Chính sách giá",
            ROOM_PLAN_SUB_TITLE: "Khai báo tối thiểu 1 chính sách giá",
            HOTEL_CONFIG: "Cấu hình khách sạn",
            HOTEL_CONFIG_SUB_TITLE: "Điền đầy đủ các trường bắt buộc",
            BOOKING_CANCEL_POLICY: "Chính sách huỷ đặt phòng",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "Khai báo tối thiểu 1 chính sách",
            PAYMENT_GATE: "Cổng thanh toán",
            PAYMENT_GATE_SUB_TITLE: "Tối thiểu 1 phương thức thanh toán",
            CONTRACT: "Hợp đồng",
            CONTRACT_SUB_TITLE: "Điền đầy đủ các trường bắt buộc",
            PAYMENT_POLICY: "Chính sách thanh toán",
            PAYMENT_POLICY_SUB_TITLE: "Khai báo tối thiểu 1 chính sách",
            CLOSE: "Đóng"
        },
        CONFIRM: "Xác nhận",
        CONFIRM_SELL_ROOM: "Tôi đồng ý mọi thông tin đã nhập là hoàn toàn chính xác và đồng ý đăng bán phòng trên OneInventory",
        CONFIRM_SELL_ROOM_BUTTON: "Xác nhận đăng bán phòng",
        _HOTEL_STATUS_INFO: {
            CREATE: "Khởi tạo",
            WAIT_CONFIRM: "Chờ xác nhận",
            WAIT_APPROVE: "Chờ duyệt",
            APPROVED: "Đã duyệt",
            SENT_BACK: "Trả lại",
            ONSITE: "Onsite",
            OFFSITE: "Offsite"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "Chưa tạo",
            CREATE: "Khởi tạo",
            RELEASED: "Phát hành",
            WAIT_SIGN: "Chờ ký",
            COMPLETED: "Hoàn thành",
            SIGNED: "Đã ký",
            IN_DISPUTE: "Tranh chấp",
            LIQUIDATED: "Thanh lý",
            CLOSED: "Đóng"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "Chưa cài đặt",
            CONFIGURED: "Đã cài đặt"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "Đã đồng bộ",
            UNSYNCHRONIZED: "Chưa đồng bộ",
            RECEIVED: "Đã nhận",
            NOT_RECEIVED: "Chưa nhận"
        }
    },
    _BOOKING: {
        TITLE: "Danh sách đặt phòng",
        BOOKING: "0 đặt phòng | 1 đặt phòng | {count} đặt phòng",
        BOOKING_DATE: "Thời gian đặt",
        BOOKING_CODE: "Mã đặt phòng",
        REQUEST_CODE: "Mã Yêu cầu",
        REQUEST_DATE: "Ngày yêu cầu",
        REQUEST_STATUS: "Trạng thái yêu cầu",
        AGENT_NAME: "Đại lý",
        TIME_STAY: "Thời gian lưu trú",
        COMBO: "Gói đặt mua",
        COMBO_REQUEST: "Gói yêu cầu",
        AMOUNT: "Tổng cộng",
        BOOKING_STATUS: "Trạng thái đặt phòng",
        EXPORT: "Xuất Excel",
        SEARCH: "Tìm kiếm",
        RESET: "Đặt lại",
        ENTER_BOOKING_CODE: "Nhập mã đặt phòng",
        ENTER_BOOKING_CODE_OTA: "Nhập mã đặt phòng OTA",
        ENTER_BOOKING_GROUP_CODE: "Nhập mã đặt phòng đoàn",
        SEARCH_CONDITION: "Tìm kiếm theo",
        SEARCH_BOOKING_CODE: "Nhập mã",
        SEARCH_DATE: "Chọn khoảng ngày",
        EDIT: "Thao tác",
        CONFIRM_FEEDBACK: "Xác nhận gửi yêu cầu tới đại lý",
        CONFIRM_FEEDBACK_REASON: "Nội dung phản hồi",
        SEARCH_BY: {
            BOOKING_CODE: "Mã đặt phòng",
            REQUEST_DATE: "Ngày yêu cầu",
            BOOKING_DATE: "Ngày đặt phòng",
            CHECKIN_DATE: "Ngày nhận phòng",
            CHECKOUT_DATE: "Ngày trả phòng",
            STAYING_DATE: "Ngày ở"
        },
        STATUS: {
            ALL: "Tất cả",
            CANCEL: "Hủy bởi khách hàng",
            AWAIT_PAYMENT: "Chờ thanh toán",
            CLOSE: "Đã đóng",
            IN_SERVICE: "Đang sử dụng",
            PAYMENT_FAILED: "Thanh toán thất bại",
            CONFIRM: "Xác nhận",
            AWAIT_FULLY_PAYMENT: "Thanh toán một phần",
            VOID: "Hủy bởi khách sạn",
            STATUS_WAIT_FEEDBACK: "Chờ phản hồi",
            STATUS_FEEDBACK: "Đã phản hồi",
            STATUS_COMPLETE: "Hoàn thành",
            STATUS_CANCEL: "Hủy bỏ"
        },
        SEARCH_PMS_STATUS: "Trạng thái đồng bộ",
        SEARCH_PMS_CODE: "Loại PMS",
        CHECKIN_STATUS: "Trạng thái nhận phòng",
        AGENT: "Đại lý",
        MARKET: "Phân khúc thị trường",
        PDF: "Xuất PDF",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "Chi tiết đặt phòng",
        CONTACT: {
            TITLE: "Thông tin liên hệ",
            NAME: "Tên khách",
            PHONE: "Số điện thoại",
            EMAIL: "Email",
            GROUP_NAME_TOUR: "Tên đoàn khách",
            AGENT_NAME: "Đại lý"
        },
        BOOKING_DETAIL: {
            TITLE: "Thông tin đặt phòng",
            CODE: "Mã đăt phòng",
            OTACODE: "Mã đăt phòng OTA",
            STATUS: "Trạng thái đặt phòng",
            CREATED: "Ngày đặt",
            CHECK_IN: "Ngày nhận phòng",
            CHECK_OUT: "Ngày trả phòng",
            UPDATED: "Ngày cập nhật",
            NOTE: "Ghi chú"
        },
        ROOM: {
            TITLE: "Chi tiết phòng - ",
            APPLY_DATE: "Ngày",
            NAME: "Chính sách giá",
            UNIT_PRICE: "Giá tiền/đêm (VND)",
            QUANTITY: "Số lượng phòng",
            ADULTS: "Người lớn",
            CHILDREN: "Trẻ em",
            BABY: "Em bé",
            TOTAL: "Thành tiền (VND)"
        },
        PROMOTION: {
            TITLE: "Khuyến mại",
            NAME: "Tên khuyến mại",
            ROOM_PLAN_NAME: "Chính sách giá",
            ROOM_NAME: "Loại phòng",
            TOTAL: "Thành tiền (VND)"
        },
        PROMOTION_ONEI: {
            TITLE: "Khuyến mại của OneInventory",
            NAME: "Tên khuyến mại",
            COST_TYPE: "Loại chi phí",
            TOTAL: "Thành tiền (VNĐ)"
        },
        SERVICE: {
            TITLE: "Dịch vụ",
            NAME: "Tên dịch vụ",
            DATE: "Ngày sử dụng",
            COST: "Giá tiền",
            COUNT: "Số lượng",
            TOTAL: "Thành tiền (VND)"
        },
        PAYMENT_LOG: {
            TITLE: "Lịch sử thanh toán",
            METHOD: "Hình thức thanh toán",
            AMOUNT: "Số tiền",
            TRANS_NO: "Mã giao dịch",
            TRANS_DATE: "Ngày thực hiện",
            RES_CODE: "Kết quả",
            RES_MSG: "Ghi chú"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "Thanh toán Onepay nội địa",
            ONEPAY_INTER: "Thanh toán qua onepay quốc tế",
            VNPAY: "Thanh toán qua Vnpay",
            TRANSFER: "Thanh toán qua chuyển khoản",
            CASH: "Thanh toán qua tiền mặt",
            VNPAY_QR: "Thanh toán qua Vnpay QR",
            VIETTELPAY_QR: "Thanh toán qua Viettelpay QR",
            VIETTELPAY: "Thanh toán qua Viettelpay"
        },
        PAYMENT_CARD_DETAIL: "Chi tiết thẻ thanh toán",
        SUB_TOTAL: "Tổng tạm tính",
        TOTAL: "Tổng tiền:",
        PAID: "Số tiền đã thanh toán:",
        UNPAID: "Số tiền chưa thanh toán:",
        EXPORT: "In đặt phòng",
        CANCEL: "Hủy đặt phòng",
        NOTE: "Ghi chú",
        CONFIRM_CANCEL: "Xác nhận hủy đặt phòng?",
        CONFIRM_REASON: "Lý do (bắt buộc)",
        CONFIRM: "Xác nhận",
        COMMISSION: "Hoa hồng",
        BEFORE_COMMISSION: "Thực nhận",
        AFTER_COMMISSION: "Giá gồm hoa hồng",
        PAYMENT_COLLECT: "Payment collect",
        PROPERTY_COLLECT: "Property collect",
        OTA_CONTACT: "OTA contact",
        CHANNEL_COLLECT: "Channel collect"
    },
    _REQUEST_DETAIL: {
        TITLE: "Chi tiết Yêu cầu",
        BUGET: "Ngân sách chi trả",
        CONTACT: {
            TITLE: "Chi tiết liên hệ đặt phòng",
            NAME: "Tên Đại lý du lịch",
            PHONE: "Số điện thoại",
            EMAIL: "Email",
            AGENT_NAME: "Đại lý",
            REQUESTER_NAME: "Người yêu cầu"
        },
        BOOKING_DETAIL: {
            TITLE: "Chi tiết Yêu cầu",
            CODE: "Mã yêu cầu",
            STATUS: "Trạng thái đặt phòng",
            CREATED: "Ngày yêu cầu",
            CHECK_IN: "Ngày nhận phòng",
            CHECK_OUT: "Ngày trả phòng",
            UPDATED: "Ngày cập nhật"
        },
        ROOM: {
            TITLE: "Chi tiết phòng",
            APPLY_DATE: "Ngày",
            NAME: "Chính sách giá",
            UNIT_PRICE: "Giá tiền/đêm (VND)",
            QUANTITY: "Số lượng phòng",
            ADULTS: "Người lớn",
            CHILDREN: "Trẻ em",
            TOTAL: "Thành tiền (VND)"
        },
        NOTE: "Ghi chú",
        SEND_REQUEST: "Gửi phản hồi"
    },
    _BOOKING_TRANSACTION: {
        TITLE: "Giao dịch thu chi",
        ALL: "Tất cả",
        BOOKING: "đặt phòng",
        BOOKING_DATE: "Thời gian đặt",
        BOOKING_CODE: "Mã đặt phòng",
        AGENT_NAME: "Đại lý",
        TIME_STAY: "Thời gian lưu trú",
        AMOUNT: "Tổng cộng",
        PAYMENT_DATE: "Hạn thanh toán",
        BOOKING_STATUS: "Trạng thái đặt phòng",
        ACTION: "Thao tác",
        EXPORT: "Xuất Excel",
        SEARCH: "Tìm kiếm",
        CONFIRM: "Xác nhận",
        TIME_STAY_TEXT: "{day} ngày {night} đêm",
        SEARCH_CONDITION: "Tìm kiếm theo",
        SEARCH_BOOKING_CODE: "Nhập mã",
        SEARCH_DATE: "Chọn khoảng ngày",
        SEARCH_BY: {
            BOOKING_CODE: "Mã đặt phòng",
            BOOKING_DATE: "Ngày đặt phòng",
            CHECKIN_DATE: "Ngày nhận phòng",
            CHECKOUT_DATE: "Ngày trả phòng"
        },
        STATUS: {
            CANCEL: "Hủy bởi khách hàng",
            AWAIT_PAYMENT: "Chờ thanh toán",
            CLOSE: "Đã đóng",
            IN_SERVICE: "Đang sử dụng",
            PAYMENT_FAILED: "Thanh toán thất bại",
            CONFIRM: "Xác nhận",
            AWAIT_FULLY_PAYMENT: "Thanh toán một phần",
            VOID: "Hủy bởi khách sạn"
        }
    },
    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "Chi tiết giao dịch",
        DETAIL: "Chi tiết giao dịch",
        BOOKING_CODE: "Mã đặt phòng: ",
        PAYMENT_METHOD: "Hình thức thanh toán",
        TRANSACTION_CODE: "Mã giao dịch",
        TRANSACTION_DATE: "Ngày thực hiện giao dịch",
        AMOUNT: "Số tiền",
        NOTE: "Chú thích",
        BANK_TRANSFER: "Chuyển khoản",
        CASH: "Tiền mặt",
        DEBT: "Công nợ"
    },
    _ROOM_PLAN: {
        TITLE: "Phòng trống và giá",
        BATCH_UPDATE: "Cập nhật hàng loạt",
        ALL_ROOM: "Tất cả phòng",
        STOP_SELL: "Ngừng bán",
        MIN_STAY: "Số đêm ở tối thiểu",
        MAX_STAY: "Số đêm ở tối đa",
        CTA: "Không cho checkin",
        CTD: "Không cho checkout",
        CURRENT_MONTH: "Tháng {month} năm {year}",
        CONFIRM_CHANGE_PAGE: "Bạn có chắc muốn tiếp tục không?\nDữ liệu chưa lưu sẽ bị mất",
        MIN_SMALLER_THAN_ONE: "Số đêm ở tối thiểu không được nhỏ hơn 1",
        MAX_SMALLER_THAN_ONE: "Số đêm ở tối đa không được nhỏ hơn 1",
        MIN_BIGGER_THAN_MAX: "Số đêm tối thiểu lớn hơn số đêm tối đa",
        MIN_SMALLER_THAN_CONFIG: "Số đêm tối thiểu không được nhỏ hơn giá trị cấu hình trong chính sách giá tương ứng",
        MAX_BIGGER_THAN_CONFIG: "Số đêm tối đa không được nhỏ hơn giá trị cấu hình trong chính sách giá tương ứng"
    },
    _BATCH_UPDATE: {
        TITLE: "Cập nhật hàng loạt",
        ADD: "Thêm",
        SELECT_ROOM_TYPE: "Chọn loại phòng",
        SELECT_UPDATE_TYPE: "Chọn cập nhật",
        ALL_ROOM: "Tất cả phòng",
        AVAILABLE_ROOM: "Phòng trống",
        PRICE: "Giá",
        STOP_SELL: "Ngừng bán",
        CTA: "Không cho checkin",
        CTD: "Không cho checkout",
        MIN_NIGHT_STAY: "Số đêm ở tối thiểu",
        MAX_NIGHT_STAY: "Số đêm ở tối đa",
        ROOM_TYPE_AND_SALE_PACKAGE: "Loại phòng/ chính sách giá",
        FROM: "Từ",
        TO: "Đến",
        MESSAGE: {
            OVERLAP_TIME: "Khoảng thời gian cập nhật không được chồng chéo"
        },
        APPLY: "Áp dụng",
        DELETE_STOP_SELL: "Xóa ngừng bán",
        DELETE_CTA: "Xóa không cho checkin",
        DELETE_CTD: "Xóa không cho checkout"
    },
    SALE_PACKAGE: "Chính sách giá",
    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "Khách sạn",
        TITLE: "Liên kết chuỗi khách sạn",
        CHAIN_NAME: "Tên chuỗi",
        CHAIN_LIST: "Danh sách khách sạn ({total})",
        HOTEL_ID: "Mã khách sạn: ",
        ADD_HOTEL: "Thêm khách sạn",
        LOGIN_TEXT: "Đăng nhập tài khoản chủ khách sạn muốn liên kết chuỗi",
        LOGIN_EXISTED_TEXT: "Đăng nhập tài khoản {hotelName}:",
        USERNAME: "Tên đăng nhập",
        PASSWORD: "Mật khẩu",
        CONFIRM: "Xác nhận",
        REMOVE_HOTEL: "Xác nhận xoá khách sạn khỏi chuỗi?",
        LOGIN: "Đăng nhập",
        DELETE_HOTEL: "Xóa chuỗi",
        LABEL_SEARCH_CODE_NAME: "Mã/ Tên khách sạn",
        ENTER_HOTEL_NAME_OR_CODE: "Nhập thông tin mã hoặc tên khách sạn",
        CHAIN_LIST_BOOKING: "Danh sách booking",
        STATUS: "Trạng thái",
        SEARCH: "Tìm kiếm"
    },
    _ACCOUNT_SETTING: {
        TITLE: "Cài đặt tài khoản cá nhân",
        AVATAR: "Ảnh đại diện",
        USER_INFO: "Thông tin cá nhân",
        CHANGE_PASSWORD: "Đổi mật khẩu",
        USERNAME: "Tên tài khoản",
        FULLNAME: "Họ và tên",
        GENDER: "Giới tính",
        GENDER_MALE: "Nam",
        GENDER_FEMALE: "Nữ",
        EMAIL: "Email",
        PHONE_NUMBER: "Số điện thoại",
        ADDRESS: "Địa chỉ",
        POSITION: "Chức vụ",
        GROUP: "Nhóm người dùng",
        CURRENT_PASS: "Mật khẩu hiện tại",
        NEW_PASS: "Mật khẩu mới",
        NEW_PASS_REPEAT: "Nhắc lại mật khẩu mới",
        ERROR_PHONE_NUMBER_MIN: "Số điện thoại nhập ít nhất 8 ký tự",
        ERROR_PASSWORD_MIN: "Mật khẩu nhập ít nhất 8 ký tự",
        ERROR_RETYPE_PASSWORD_MIN: "Xác nhận mật khẩu nhập ít nhất 8 ký tự",
        ERROR_PASSWORD_INVALID: "Mật khẩu hiện tại không chính xác",
        ERROR_PASSWORD_NOT_MATCH: "Mật khẩu mới không trùng khớp",
        MESSAGE_PASSWORD_MATCHED: "Mật khẩu đã khớp",
        MESSAGE_PASSWORD_NOT_MATCHED: "Mật khẩu không khớp"
    },
    _LIST_USER: {
        TITLE: "Quản lý người dùng",
        LIST_USER: "Người dùng",
        USER: "người dùng",
        SEARCH_PLACEHOLDER: "Tìm kiếm theo tên tài khoản, họ tên hoặc email",
        GROUP_NAME: "Tên nhóm",
        USERNAME: "Tên tài khoản",
        NAME: "Họ tên",
        EMAIL: "Mail",
        CREATE_USER: "Người tạo",
        CREATE_DATE: "Ngày tạo",
        STATUS: "Trạng thái",
        ACTION: "Thao tác",
        STATUS_ACTIVATE: "Đang hoạt động",
        STATUS_DEACTIVATE: "Ngừng hoạt động",
        REMOVE: "Xác nhận xóa người dùng này?",
        CANNOT_DELETE_CURRENT_USER: "Không thể xóa tài khoản người dùng hiện tại"
    },
    _LIST_GROUP: {
        TITLE: "Quản lý nhóm người dùng",
        LIST_GROUP: "Nhóm người dùng",
        GROUP: "nhóm người dùng",
        SEARCH_PLACEHOLDER: "Tìm kiếm theo tên nhóm người dùng",
        GROUP_NAME: "Tên nhóm",
        CREATE_USER: "Người tạo",
        CREATE_DATE: "Ngày tạo",
        STATUS: "Trạng thái",
        ACTION: "Thao tác",
        STATUS_ACTIVATE: "Đang hoạt động",
        STATUS_DEACTIVATE: "Ngừng hoạt động",
        DESCRIPTION: "Thông tin mô tả",
        REMOVE: "Xác nhận xóa nhóm này?"
    },
    _EDIT_USER: {
        TITLE: "Thông tin người dùng",
        INFO: "Thông tin người dùng",
        USER: "Người dùng",
        ROLE: "Quyền truy cập",
        USERNAME: "Tên tài khoản",
        FULLNAME: "Họ và tên",
        PASSWORD: "Mật khẩu",
        PASSWORD_REPEAT: "Xác nhận mật khẩu",
        GENDER: "Giới tính",
        GENDER_MALE: "Nam",
        GENDER_FEMALE: "Nữ",
        EMAIL: "Email",
        PHONE_NUMBER: "Số điện thoại",
        ADDRESS: "Địa chỉ",
        POSITION: "Chức vụ",
        GROUP: "Nhóm người dùng",
        GROUP_PLACEHOLDER: "Tìm kiếm",
        HOTEL_OWNER: "Chủ khách sạn",
        STATUS: "Trạng thái hoạt động/ Ngừng hoạt động",
        NO: "STT",
        FUNCTION_CODE: "Mã chức năng",
        FUNCTION_NAME: "Tên chức năng",
        ACTION: "Thao tác",
        ERROR_PHONE_NUMBER_MIN: "Số điện thoại nhập ít nhất 8 ký tự",
        ERROR_PASSWORD_MIN: "Mật khẩu nhập ít nhất 8 ký tự",
        ERROR_RETYPE_PASSWORD_MIN: "Xác nhận mật khẩu nhập ít nhất 8 ký tự",
        ERROR_PASSWORD_NOT_MATCH: "Mật khẩu không trùng khớp",
        CHAIN: "Chuỗi khách sạn",
        HOTEL: "Khách sạn"
    },
    _EDIT_GROUP: {
        TITLE: "Thông tin nhóm người dùng",
        INFO: "Thông tin nhóm người dùng",
        GROUP: "Nhóm người dùng",
        ROLE: "Quyền truy cập",
        GROUP_NAME: "Tên nhóm",
        GROUP_CODE: "Mã nhóm",
        GROUP_ROLE: "Loại quyền",
        PARENT_GROUP: "Nhóm cha",
        TYPE: "Kiểu nhóm",
        DESCRIPTION: "Thông tin mô tả",
        STATUS: "Trạng thái hoạt động/ Ngừng hoạt động",
        NO: "STT",
        FUNCTION_CODE: "Mã chức năng",
        FUNCTION_NAME: "Tên chức năng",
        ACTION: "Thao tác",
        ERROR_MIN_ROLE_SELECTED: "Vui lòng chọn ít nhất 1 màn hình chức năng"
    },
    _CONTRACT: {
        TITLE: "Hợp đồng điện tử",
        CONTRACT_INFO: "Thông tin pháp nhân",
        BUSINESS_NAME: "Tên doanh nghiệp",
        BUSINESS_NAME_NOTE: " (Điền đúng theo GPKD, viết hoa)",
        TAX_CODE: "Mã số thuế",
        TAX_CODE_NOTE: " (Điền đúng và đủ cả chữ số 0)",
        ADDRESS: "Địa chỉ đăng ký kinh doanh",
        ADDRESS_NOTE: " (Điền đúng theo GPKD)",
        BANK_ACCOUNT: "Số tài khoản ngân hàng",
        BANK_ACCOUNT_OWNER: "Tên chủ tài khoản",
        BANK: "Tên ngân hàng",
        BANK_BRANCH: "Chi nhánh ngân hàng",
        LEGAL_REPRESENTATIVE: "Đại diện pháp luật",
        LEGAL_REPRESENTATIVE_NOTE: " (Điền đúng theo GPKD)",
        PIC: "Người ký hợp đồng",
        PIC_POSITION: "Chức vụ người ký",
        COMMISSION: "Hoa hồng (%)",
        STATUS: "Trạng thái hợp đồng",
        VIEW: "Xem",
        _STATUS: {
            CREATE: "Khởi tạo",
            AM_SENT: "AM gửi duyệt",
            SM_ACCEPT: "SM đã duyệt",
            SM_REJECT: "SM trả lại",
            CM_ACCEPT: "CM đã duyệt",
            CM_REJECT: "CM trả lại",
            PUBLISH: "Phát hành",
            WAIT_SIGN: "Chờ ký",
            COMPLETE: "Hoàn thành",
            SIGNED: "Đã ký",
            DISPUTED: "Tranh chấp",
            LIQUIDFY: "Thanh lý",
            CLOSE: "Đóng",
            EXTEND: "Gia hạn"
        }
    },
    _TRAVEL_AGENT: {
        TITLE: "Danh sách đại lý",
        TITLE_DEACTIVE: "Danh sách đại lý ngừng hợp tác",
        AGENT: "đại lý",
        SEARCH_PLACEHOLDER: "Tìm kiếm theo tên đại lý",
        NAME: "Tên đại lý",
        BUSINESS_TYPE: "Loại hình kinh doanh",
        TAX_CODE: "Mã số thuế",
        LEVEL: "Phân loại đại lý",
        STATUS: "Tình trạng",
        DEACTIVE: "Hủy liên kết",
        ACTIVE: "Quay lại liên kết",
        LEVEL_1: "Cấp 1",
        LEVEL_2: "Cấp 2",
        LEVEL_3: "Cấp 3",
        LEVEL_4: "Cấp 4",
        LEVEL_5: "Cấp 5",
        CONFIRM_CHANGE_LEVEL: "Xác nhận thay đổi level?",
        CONFIRM_ACTIVE: "Xác nhận liên kết với đại lý?",
        CONFIRM_DEACTIVE: "Xác nhận hủy liên kết đại lý?",
        CONFIRM_REASON: "Lý do (bắt buộc)",
        CONFIRM: "Xác nhận",
        CONFIRM_CHANGE_ACTIVE: "Xác nhận thay đổi trạng thái đại lý"
    },
    ONEPAY_INLAND: "OnePay nội địa",
    ONEPAY_OVERSEA: "OnePay quốc tế",
    VN_PAY: "VN Pay",
    NEAREST_POPULAR_LOCATION: "Địa điểm phổ biến gần nhất",
    MOST_POPULAR_LOCATION: "Địa điểm phổ biến nhất",
    RESTAURANT_AND_MARKET: "Nhà hàng và chợ",
    TRAVEL_PLACE: "Địa điểm du lịch",
    NEAREST_AIRPORT: "Sân bay gần nhất",
    VIETNAMESE_NAME: "Tên tiếng Việt",
    ENGLISH_NAME: "Tên tiếng Anh",
    ADD_LOCATION: "Thêm địa điểm",
    DISTANCE: "Khoảng cách",
    ROOM_INFOMATION: "Thông tin phòng",
    ROOM_AMENITIES: "Tiện ích phòng",
    ROOM_IMAGE: "Hình ảnh phòng",
    ROOM_NAME: "Tên phòng",
    ROOM_TYPE: "Loại phòng",
    MEAL: "Bữa ăn",
    NAME_ROOM_TYPE: "Tên loại phòng",
    NAME_ROOM_TYPE_DEFAULT: "Tên loại phòng mặc định",
    TOTAL_ROOM: "Tổng số phòng",
    MAX_CUSTOMER_COUNT: " Số khách tối đa",
    ROOM_DIMENSION: "Kích thước phòng",
    BED_BONUS_COUNT: "Số lượng giường thêm",
    PRICE_NORMAL_DAY: "Giá ngày thường",
    PRICE_WEEKEND: "Giá cuối tuần",
    ROOM_DIRECTION: "Hướng phòng",
    BED_TYPE: "Loại giường",
    ADULT: "Người lớn",
    CHILDREN: "Trẻ em",
    ACTION: "Thao tác",
    COMMON_BED_TYPE: "Loại giường thông thường",
    COMBINATION_BED_TYPE: "Loại giường kết hợp",
    MORE_OPTIONS: "Thêm tùy chọn",
    REMOVE_OPTIONS: "bỏ tùy chọn",
    ADD_TYPE_BED: "Thêm loại giường",
    FREE: "Miễn phí",
    SURCHARGE: "Phụ phí",
    PACKAGE: "gói",
    SELLING_PACKAGE_INFO: "Thông tin chính sách giá",
    SELLING_PACKAGE: "Tên chính sách giá",
    SERVICE_PACKAGE: "Gói dịch vụ",
    PROMOTION: "Khuyến mại",
    PROMOTION_INFO: "Thông tin khuyến mại",
    NAME_SELLING_PACKAGE: "Tên chính sách giá",
    PACKEAGE_APPLY_FOR: "chính sách giá áp dụng cho",
    MEALS_INCLUDE: "Bữa ăn bao gồm",
    EXTRA_BED_PRICE: "Giá giường thêm",
    EXTRA_ADULT_PRICE: "Giá thêm người lớn",
    EXTRA_CHILD_PRICE: "Giá thêm trẻ em",
    MIN_NIGHT: "Số đêm ở tối thiểu",
    MAX_NIGHT: "Số đêm ở tối đa",
    DAYS_NOT_APPLY: "Ngày không áp dụng",
    NOT_APPLY: "Không áp dụng",
    ADD_DAYS_NOT_APPLY: "Thêm ngày không áp dụng",
    TYPE_ROOM_APPLIED: "Loại phòng áp dụng",
    PLAN_IS_SELECTING: "Gói bán đã được kết nối với OTA",
    PLAN_NULL: "Gói bán phòng không tồn tại",
    PLAN_IS_SELECTING: " Chính sách giá đã được sử dụng",
    PLAN_NULL: "Chính sách giá không tồn tại",
    ERROR: "Rất tiếc, đã xảy ra lỗi không mong muốn. Vui lòng thử lại sau.",
    COPY_SUCCESS: "Sao chép thành công",
    COPPY_SUCCESS: "Sao chép thành công",
    NOT_SELECTED_PLAN: "Không có gói nào được chọn",
    NOT_SELECTED_ROOM: "Không có phòng nào được chọn",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "Số đêm ở tối đa không được nhỏ hơn số đêm tối thiểu",
    PROMOTION_PACKAGE_NAME: "Tên khuyến mại",
    PROMOTION_TYPE: "Hình thức khuyến mại",
    APPLY: "Áp dụng",
    APPLY_WITH: "Áp dụng với",
    DISCOUNT_AND_SURCHARGES: "Mức giảm giá/ phụ phí",
    DAYS_APPLY: "Ngày trong tuần áp dụng",
    TIME_STAY: "Thời gian ở",
    TIME_SET: "Thời gian đặt",
    TARGET_APPLY: "Đối tượng áp dụng",
    ARGENT_LEVEL_APPLY: "Chọn cấp đại lý áp dụng",
    ARGENT_APPLY: "Chọn đại lý áp dụng",
    PACKAGE_APPLY: "chính sách giá áp dụng",
    X_DAYS: "x ngày",
    FROM_DATE: "Từ ngày",
    TO_DATE: "Đến ngày",
    MIN_COUNT: "Số lượng tối thiểu",
    NIGHT_STAY: "Số đêm nghỉ lại",
    ROOM_BOOK_QUANTITY: "Số lượng phòng đặt",
    QUANTITY_IS_FREE: "Số lượng được miễn phí (y)",
    COUPON: "Mã giảm giá",
    STATUS: "Trạng thái",
    ACTIVE: "Đang hoạt động",
    DEACTIVE: "Ngừng hoạt động",
    STATE_ACTIVE_OR_DEACTIVE: "Trạng thái hoạt động/ Tạm ngừng hoạt động",
    CBALERT_LB_AVAISEARCH: "Vui lòng chọn một hoặc nhiều",
    CONTACT_BOOKING_DETAIL: "Chi tiết liên hệ đặt phòng",
    BOOKING_DETAIL: "Chi tiết đặt phòng",
    NORMAL_ROOM_DETAIL: "Chi tiết phòng cơ sở",
    VIP_ROOM_DETAIL: "Chi tiết phòng VIP",
    SERVICES: "Dịch vụ",
    PAYMENT_HISTORY: "Lịch sử thanh toán",
    FILE_NAME: "Tên tệp",
    FILE_TYPE: "Loại tệp",
    UPLOAD_BY: "Tải lên bởi",
    FILE_CAPACITY: "Dung lượng tệp",
    SIZE: "Kích thước",
    UPLOAD_TIME: "Thời gian tải ảnh",
    CLOSE: "Đóng",
    TOTAL: "Tổng",
    OR: "hoặc",
    CHOOSE: "Chọn",
    NO_PHOTOS_FOUND: "Không tìm thấy ảnh nào",
    DRAG_DROP_PHOTOS_HERE: "Kéo thả ảnh vào đây",
    SELECT_PHOTOS_TO_UPLOAD: "Chọn ảnh tải lên",
    MAXIMUM_CAPACITY: "Dung lượng tối đa",
    LOADING: "Đang tải",
    EMAIL_CONFIGURATION: "Cấu hình email",
    HOTEL_EMAIL: "Email khách sạn",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "Email nhận thông báo đặt phòng",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "Email đồng gửi nhận thông báo đặt phòng (cc email)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "Email đồng gửi nhận thông báo đặt phòng (bcc email)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "Ngôn ngữ hiển thị và ngày cuối tuần",
    DISPLAY_LANGUAGE: "Ngôn ngữ hiển thị",
    WEEKEND: "Ngày cuối tuần",
    CURRENCY_AND_TAXES_FEES: "Đơn vị tiền tệ và mức thuế/ phí",
    CURRENCY_USED_IN_SYSTEM: "Đơn vị tiền tệ sử dụng trong hệ thống",
    VAT_RATE_IS_APPLIES: "Mức % thuế VAT được áp dụng",
    SERVICE_TAX_RATE_APPLIES: "Mức % phí dịch vụ được áp dụng",
    PRICES_INCLUDE_TAXES_FEES: "Giá đã bao gồm thuế/ phí",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "Quy định về độ tuổi trẻ em và mức phí đi kèm",
    YOUTH_IS_FREE_OF_CHARGE: "Độ tuổi em bé tối đa",
    AGE_CHILD_EXTRA_CHARGE: "Độ tuổi trẻ em tối đa",
    OTHER_INFOMATION: "Thông tin khác",
    CHECKIN_TIME: "Thời gian nhận phòng",
    CHECKOUT_TIME: "Thời gian trả phòng",
    YEAR_BUILT: "Năm xây dựng",
    TOTAL_NUMBER_OF_FLOORS: "Tổng số tầng",
    DISTANCE_TO_AIRPORT: "Khoảng cách tới sân bay",
    DISTANCE_TO_CITY_CENTER: "Khoảng cách tới trung tâm thành phố",
    TIME_TO_AIRPORT: "Thời gian tới sân bay (phút)",
    VOLTAGE_USED: "Điện áp sử dụng",
    ROOM_SERVICE: "Dịch vụ phòng",
    HOTEL_RULES: "Quy định của khách sạn",
    EFFECTIVE_DATE: "ngày hiệu lực",
    DEPOSIT_BEFORE_CHECKIN: "Đặt cọc trước x ngày",
    PERCENT: "phần trăm",
    AMOUNT_OF_MONEY: "số tiền",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "Thanh toán trước ngày nhận phòng",
    PAYMENT_BEFORE_CHECKOUT_DATE: "Thanh toán vào ngày trả phòng",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "Thanh toán vào ngày nhận phòng",
    ADD_NEW_PAYMENT_POLICY: "Thêm mới chính sách thanh toán",
    DEPOSIT_LEVEL_APPLIES: "Mức đặt cọc áp dụng",
    TIME_APPLICATION: "Thời gian áp dụng",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "Hủy đặt phòng trong vòng x ngày trước ngày nhận phòng",
    FIXED_MONEY: "số tiền cố định",
    ADD_NEW_CANCELLATION_POLICY: "Thêm mới chính sách hủy đặt phòng",
    FINES_APPLY: "Mức phạt áp dụng",
    PERSONAL_ACCOUNT_SETTING: "Cài đặt tài khoản cá nhân",
    LOG_OUT: "Thoát",
    _LOGIN: {
        LOGIN: "Đăng nhập",
        USERNAME: "Tên đăng nhập",
        PASSWORD: "Mật khẩu",
        FORGOT_PASSWORD: "Quên mật khẩu",
        REGISTER_NOW: "Đăng ký ngay",
        LOOKING_AGENT: "Tìm kiếm trang dành cho đại lý?",
        LOGIN_HERE: "Đăng nhập tại đây",
        SESSION_EXPIRED: "Phiên làm việc của bạn đã hết!",
        HAS_NO_ACCESS: "Tài khoản đăng nhập không có hiệu lực! ",
        SESSION_EXPIRED_MESSAGE: "Vì lý do bảo mật, phiên hết hạn sau khi hết thời gian không có hoạt động. Để tiếp tục, nhập tên người dùng và mật khẩu của bạn và đăng nhập",
        INVALID_ACCOUNT_INFO_MESSAGE: "Tên đăng nhập hoặc mật khẩu không đúng!",
        ARE_YOU_FORGOT_PASSWORD: "Bạn quên mật khẩu?",
        ENTER_EMAIL_USERNAME: "Nhập địa chỉ email hoặc tên đăng nhập của bạn để khôi phục mật khẩu!",
        EMAIL_USERNAME: "Email hoặc tên đăng nhập",
        EMAILADDRESS_ERROR_REQUIRED: "Xin kiểm tra lại định dạng Email!!",
        EMAIL_NOT_EXIST: "Email hoặc tên đăng nhập không tồn tại, vui lòng kiểm tra lại!",
        REQUEST_RESET_PASS_NOTICE: "Yêu cầu khôi phục mật khẩu của bạn thành công",
        SEND_NEW_PASS: "Mật khẩu mới của bạn đã được gửi đi, hãy kiểm tra trong Email",
        CANCEL: "Hủy bỏ",
        RESET: "Xác nhận",
        HOTELID: "Mã khách sạn",
        EZID_LOGIN: "Đăng nhập với ezID"
    },
    _RESET: {
        NOT_VALID_REQUEST: "Yêu cầu đổi mật khẩu không còn hiệu lực"
    },
    _REGISTER: {
        OTA_GROUP: "Nhóm kênh",
        OTA: "Kênh bán",
        WELCOME: "Chào mừng bạn đến với ezCrs - Được thiết kế đặc biệt cho Khách sạn",
        SOLOGAN: "Hãy đăng ký với chúng tôi hôm nay & chúng tôi sẽ hỗ trợ bạn từ đầu đến cuối. Bạn có thể đặt nhiều loại sản phẩm với chúng tôi và bán cho khách hàng của bạn. Tham gia với chúng tôi ngay bây giờ !!!",
        PERSONAL_DETAIL: "Thông tin cá nhân",
        HOTEL_DETAIL: "Thông tin khách sạn",
        CREATE_ACCOUNT: "Tạo tài khoản",
        ENTER: "Nhập",
        ENTER_TAX_CODE: "Nhập mã số thuế",
        ENTER_ROOM_QUANTITY: "Nhập tổng số phòng",
        YOUR_COMPANY_NAME: "Công ty/Thương hiệu của bạn",
        YOUR_WEBSITE_LINK: "Đường dẫn website của bạn",
        SELECT: "Chọn",
        REQUIRED: "Bắt buộc",
        FULLNAME: "Họ và tên",
        YOUR_FULLNAME: "Họ và tên của bạn",
        PERSONAL_PHONE: "Số điện thoại cá nhân",
        MALE: "Nam",
        FEMALE: "Nữ",
        EMAIL: "Email",
        YOUR_EMAIL: "Email của bạn",
        POSITION: "Chức vụ",
        YOUR_POSITION: "Chức vụ của bạn",
        HOTEL_NAME: "Tên khách sạn",
        HOTEL_TYPE: "Loại khách sạn",
        TAX_CODE: "Mã số thuế",
        COUNTRY: "Quốc gia",
        WARD: "Khu vực",
        WEBSITE: "Website",
        STAR: "Hạng sao",
        CITY: "Tỉnh/Thành phố",
        ADDRESS: "Địa chỉ",
        HOTEL_PHONE: "Số điện thoại khách sạn",
        HOTEL_EMAIL: "Email của khách sạn",
        ENTER_EMAIL: "Nhập email",
        NUMBER_OF_ROOMS: "Số phòng",
        DISTRICT: "Phường/Xã/Đặc khu",
        USERNAME: "Tên đăng nhập",
        CREATE_NEW_ACCOUNT_NAME: "Tạo tên tài khoản mới",
        PASSWORD: "Mật khẩu",
        CREATE_PASSWORD: "Tạo mật khẩu",
        RETYPE_PASSWORD: "Nhập lại mật khẩu",
        PHONE_NUMBER_NOT_LESS_THAN: "Số điện thoại nhập ít nhất 8 ký tự",
        PASSWORD_NOT_LESS_THAN: "Mật khẩu không ít hơn 8 kí tự",
        VALID_USERNAME_MESSAGE: "Chọn tên người dùng chỉ chứa chữ cái và số",
        BY_CLICKING_REGISTER: "Để tiếp tục, bạn hãy đồng ý với",
        TERM_AND_CONDITIONS: "Điều khoản và điều kiện",
        PRIVACY_POLICY: "chính sách bảo mật của chúng tôi",
        AGREE_POLICY_MESSAGE: "Để tiếp tục, bạn hãy đồng ý với Điều khoản và điều kiện & chính sách bảo mật của chúng tôi",
        THANKS_FOR_REGISTER: "Cảm ơn bạn đã đăng ký !",
        WAIT_APPROVE: "Tài khoản của bạn đã được đăng ký thành công và đang chờ phê duyệt.",
        UPLOAD_CERTIFICATE_MESSAGE: "Vui lòng tải lên giấy chứng nhận đăng ký Kinh doanh để giúp chúng tôi xác minh và cấp tài khoản. Chúng tôi sẽ xác nhận tài khoản của bạn trong vòng 48 giờ.",
        REQUIRED_FIELD: "Trường bắt buộc",
        ACCOUNT_ALREADY_EXISTS: "Tài khoản đã tồn tại",
        PASSWORD_NOT_MATCH: "Mật khẩu không trùng khớp",
        REGISTER: "Đăng ký",
        NEXT: "Tiếp theo",
        BACK: "Quay lại",
        UPLOAD_FILE: "Tải tệp lên",
        COMPLETE_AND_LOGIN: "Hoàn thành và Quay lại trang chủ"
    },
    _LEFT_MENU: {
        COPY_RIGHT: "Bản quyền © 2021 ezCloud bảo lưu mọi quyền"
    },
    _ACTIVITY: {
        ACTION_DATE: "Ngày thao tác",
        ACTION_BY: "Người thao tác",
        APPLY_DATE: "Ngày áp dụng",
        CREATED_DATE: "Ngày tạo",
        ROOM_NAME: "Tên phòng",
        RATE: "Giá",
        CREATE_DATE: "Ngày tạo",
        SEARCH_DATE: "Ngày áp dụng",
        USER_NAME: "Tài khoản",
        ROOM: "Phòng",
        ROOM_PLAN: "Gói loại phòng",
        YES: "Có",
        NO: "Không",
        STOPSELL: "Ngừng bán",
        MINSTAY: "Ngày ở tối thiểu",
        CLOSEDTOARRIVE: "Không cho checkin",
        MAXSTAY: "Ngày ở tối đa",
        CLOSEDTODEPATURE: "Không cho checkout",
        IPADDRESS: "Địa chỉ IP",
        CREATEDBY: "Người tạo",
        PAGING: "Trang",
        DOCUMENT: "Bản ghi",
        ROOMAVAIL: "Số phòng trống",
        ALLSELECT: "Tất cả",
        HOTELID: "Hotel ID",
        HOTELNAME: "Tên khách sạn",
        DATABEFORE: "Dữ liệu trước",
        DATAAFTER: "Dữ liệu sau",
        ACTION: "Thao tác",
        HOTEL_LOGIN: "Đăng nhập",
        HOTEL_CANCEL_BOOKING: "Hủy đặt phòng",
        HOTEL_UPDATE_PAYMENT_BOOKING: "Xác nhận đặt phòng",
        HOTEL_REQUEST_BOOKING: "Xác nhận yêu cầu đặt phòng",
        HOTEL_ROOM_PLAN_CREATE: "Thêm mới chính sách giá",
        HOTEL_ROOM_PLAN_UPDATE: "Cập nhật chính sách giá",
        HOTEL_ROOM_PLAN_COPY: "Sao chép chính sách giá",
        HOTEL_ROOM_PLAN_DELETE: "Xóa chính sách giá",
        HOTEL_PROMOTION_CREATE: "Thêm khuyến mại",
        HOTEL_PROMOTION_UPDATE: "Cập nhật khuyến mại",
        HOTEL_PROMOTION_COPY: "Sao chép khuyến mại",
        HOTEL_PROMOTION_DELETE: "Xóa khuyến mại",
        HOTEL_PROFILE_UPDATE: "Cập nhật thông tin cá nhân",
        HOTEL_AVATAR_ADD: "Thêm ảnh đại diện",
        HOTEL_AVATAR_REMOVE: "Xóa ảnh đại diện",
        HOTEL_CHANGE_PASSWORD_PROFILE: "Đổi mật khẩu",
        HOTEL_USER_CREATE: "Thêm người dùng",
        HOTEL_USER_UPDATE: "Cập nhật người dùng",
        HOTEL_USER_UPDATE_ROLE: "Cập nhật quyền người dùng",
        HOTEL_USER_DELETE: "Xóa người dùng",
        HOTEL_GROUP_CREATE: "Thêm nhóm người dùng",
        HOTEL_GROUP_UPDATE: "Cập nhật nhóm người dùng",
        HOTEL_GROUP_UPDATE_ROLE: "Cập nhật quyền nhóm người dùng",
        HOTEL_GROUP_DELETE: "Xóa nhóm người dùng",
        HOTEL_CONTRACT_UPDATE: "Cập nhật thông tin hợp đồng",
        HOTEL_INFO_UPDATE: "Cập nhật thông tin khách sạn",
        HOTEL_UPDATE_AMENITIES: "Cập nhật tiện ích",
        HOTEL_UPDATE_IMAGES: "Thêm ảnh thư viện",
        HOTEL_DELETE_IMAGES: "Xóa ảnh thư viện",
        HOTEL_AREA_CREATED: "Thêm vùng lân cận",
        HOTEL_AREA_UPDATED: "Cập nhật vùng lân cận",
        HOTEL_AREA_DELETED: "Xóa vùng lân cận",
        HOTEL_CHAIN_CREATED: "Thêm chuỗi khách sạn",
        HOTEL_CHAIN_UPDATED: "Cập nhật chuỗi khách sạn",
        HOTEL_ROOM_CREATED: "Thêm loại phòng",
        HOTEL_ROOM_UPDATED: "Cập nhật thông tin loại phòng",
        HOTEL_ROOM_COPY: "Sao chép loại phòng",
        HOTEL_ROOM_DELETED: "Xóa loại phòng",
        HOTEL_ROOM_AMENITY: "Cập nhật thông tin tiện ích phòng",
        HOTEL_ROOM_ADD_IMAGES: "Thêm ảnh loại phòng",
        HOTEL_ROOM_DELETE_IMAGES: "Xóa ảnh loại phòng",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "Cập nhật cấu hình khách sạn",
        HOTEL_PAYMENT_POLICY_CREATED: "Thêm mới chính sách thanh toán",
        HOTEL_PAYMENT_POLICY_UPDATED: "Cập nhật chính sách thanh toán",
        HOTEL_PAYMENT_POLICY_DELETED: "Xóa chính sách thanh toán",
        HOTEL_CANCEL_POLICY_CREATED: "Thêm mới chính sách hủy đặt phòng",
        HOTEL_CANCEL_POLICY_UPDATED: "Cập nhật chính sách hủy đặt phòng",
        HOTEL_CANCEL_POLICY_DELETED: "Xóa chính sách hủy đặt phòng",
        HOTEL_SETTING_PAYMENT_GATE: "Cấu hình cổng thanh toán",
        HOTEL_ADD_IMAGES_SLIDE: "Cập nhật ảnh khách sạn",
        HOTEL_DELETE_IMAGES_SLIDE: "Xóa ảnh khách sạn",
        HOTEL_REMOVE_CONNECT_AGENT: "Hủy liên kết đại lý",
        HOTEL_UPDATE_LEVEL_AGENT: "Cập nhật cấp liên kết đại lý",
        HOTEL_RETURN_CONNECT_AGENT: "Quay lại liên kết đại lý",
        PMS_CONFIRM: "Xác nhận đồng bộ",
        RATE_CATEGORY_CREATE: "Tạo mới danh mục giá",
        RATE_CATEGORY_UPDATE: "Chi tiết danh mục giá",
        ROOM_CATEGORY_CREATE: "Tạo mới danh mục phòng",
        ROOM_CATEGORY_UPDATE: "Chi tiết danh mục phòng"
    },
    STATUS_CREATE_NEW: "Khởi tạo",
    STATUS_DELIVERED: "Đã giao",
    STATUS_SALE_SEND_HOTEL: "Gửi duyệt KS",
    STATUS_SALE_ADMIN_SEND_BACK: "SM trả lại",
    STATUS_SALE_ADMIN_PASSED: "SM đã duyệt",
    STATUS_QC_SENT_BACK_HOTEL: "QC trả lại",
    STATUS_QC_PASSED_HOTEL: "QC đã duyệt",
    STATUS_SALE_ADDITIONAL: "Gửi duyệt TT",
    STATUS_QC_SENT_BACK_INFOR: "Trả lại TT",
    STATUS_QC_PASSED_INFOR: "Đã duyệt TT",
    STATUS_ONSITE: "Onsite",
    STATUS_OFFSITE: "Offsite",
    STATUS_RELEASED: "Phát hành",
    STATUS_SIGNED: "Đã ký",
    STATUS_WAITING_SIGN: "Chờ ký",
    STATUS_CLOSED: "Đã đóng",
    STATUS_IN_DISPUTE: "Tranh chấp",
    STATUS_LIQUIDATED: "Thanh lý",
    STATUS_COMPLETED: "Hoàn thành",
    STATUS_CM_PASSED: "CM đã duyệt",
    STATUS_CM_SEND_BACK: "CM trả lại",
    STATUS_RENEWAL: "Khởi tạo",
    STATUS_CHANGED: "đã chuyển trạng thái sang",
    STATUS_AWAIT_PAYMENT: "AWAIT_PAYMENT",
    STATUS_AWAIT_FULLY_PAYMENT: "AWAIT_FULLY_PAYMENT",
    STATUS_PAYMENT_FAILED: "PAYMENT_FAILED",
    STATUS_CONFIRM: "CONFIRM",
    ALL: "Tất cả",
    CANCEL: "Hủy bởi khách hàng",
    AWAIT_PAYMENT: "Chờ thanh toán",
    IN_SERVICE: "Đang được sử dụng",
    PAYMENT_FAILED: "Thanh toán thất bại",
    AWAIT_FULLY_PAYMENT: "Thanh toán 1 phần",
    VOID: "Hủy bỏ bởi khách sạn",
    STATUS_WAIT_FEEDBACK: "Chờ phản hồi",
    STATUS_FEEDBACK: "Đã phản hồi",
    STATUS_COMPLETE: "Hoàn thành",
    STATUS_CANCEL: "Đã hủy",
    BOOKING: "Đặt phòng",
    BOOKING_STATUS: "Trạng thái Đặt phòng",
    BOOKING_REQUEST_STATUS: "Trạng thái Send Request",
    CONTRACT_STATUS: "Trạng thái hợp đồng",
    TA_STATUS: "Trạng thái đại lý",
    HOTEL_STATUS: "Trạng thái khách sạn",
    SHOW_MORE: "Hiển thị thêm",
    NOTIFICATION: "Thông báo",
    HAS_JUST_JOINED_ONEI: "vừa tham gia OneInventory.com",
    HAS_JUST_CREATED_ONEI: "được tạo mới trên OneInventory.com",
    ANNEX_OF_CONTRACT: "Phụ lục hợp đồng số",
    HOTELS_CONTRACT: "Hợp đồng của Khách sạn",
    YOUR_AGENT: "Đại lý của bạn",
    MARK_AS_READ: "Đánh dấu là đã đọc",
    CONTACT_NUMBER: "Hợp đồng số",
    BELONG_HOTEL: "của Khách sạn",
    AGENT: "Đại lý",
    ADDENDUM_OF_CONTRACT: "Phụ lục hợp đồng số",
    NEW_TA: "Đại lý mới",
    STATUS_NEW_CREATE: "Khởi tạo",
    EXTEND_CONTRACT: "Gia hạn",
    RE_RELEASE: "Phát hành lại",
    AGO: "trước",
    MONTHS: "tháng",
    YEARS: "năm",
    SECONDS: "giây",
    MINUTES: "phút",
    HOURS: "giờ",
    NOW: "vừa xong",
    DAYS: "ngày",
    REQUEST_EMPTY: "Không tìm thấy yêu cầu",
    STATUS_INCORRECT: "Trạng thái khác chờ phản hồi",
    STATUS_CONTRACT_INCORRECT: "Trạng thái hợp đồng khác đã ký",
    NO_NOTIFICATION: "Không có thông báo mới nào",
    ADDENDUM_STATUS: "Trạng thái phụ lục hợp đồng",
    OVER_CHARACTER: "Bạn đã vượt quá kí tự cho phép",
    HOTEL_LOG_bookingCode: "Mã đặt phòng",
    HOTEL_LOG_agentName: "Tên đại lý",
    HOTEL_LOG_customer: "Khách hàng",
    HOTEL_LOG_createdDate: "Ngày tạo",
    HOTEL_LOG_checkinDate: "Ngày check in",
    HOTEL_LOG_checkoutDate: "Ngày check out",
    HOTEL_LOG_totalCost: "Tổng tiền",
    HOTEL_LOG_payableAmount: "Số tiền đã thanh toán",
    HOTEL_LOG_bookingStatus: "Trạng thái đặt phòng",
    HOTEL_LOG_active: "Hoạt động",
    HOTEL_LOG_amount: "Số tiền / Phần trăm",
    HOTEL_LOG_cancellationDay: "Hủy trước số ngày",
    HOTEL_LOG_cancellationType: "Hình thức áp dụng",
    HOTEL_LOG_startDate: "Ngày bắt đầu",
    HOTEL_LOG_endDate: "Ngày kết thúc",
    HOTEL_LOG_hotelId: "Mã khách sạn",
    HOTEL_LOG_type: "Thời gian áp dụng",
    HOTEL_LOG_notifyToEmail: "Email nhận thông báo",
    HOTEL_LOG_notifyCCEmail: "Email được CC thông báo",
    HOTEL_LOG_notifyBCCEmail: "Email được BCC thông báo",
    HOTEL_LOG_includeTaxesInPrice: "Giá đã bao gồm thuế phí",
    HOTEL_LOG_language: "Ngôn ngữ",
    HOTEL_LOG_weekend: "Ngày cuối tuần",
    HOTEL_LOG_email: "Email",
    HOTEL_LOG_checkinAfterHour: "Giờ nhận phòng",
    HOTEL_LOG_checkoutBeforeHour: "Giờ trả phòng",
    HOTEL_LOG_roomServices: "Dịch vụ phòng",
    HOTEL_LOG_hotelPolicyVi: "Quy định khách sạn VI",
    HOTEL_LOG_hotelPolicyEn: "Quy định khách sạn EN",
    HOTEL_LOG_yearOfBuild: "Năm xây dựng",
    HOTEL_LOG_numberOfFloors: "Tổng số tầng",
    HOTEL_LOG_numberOfRooms: "Tổng số phòng",
    HOTEL_LOG_minutesToAirport: "Thời gian tới sân bay",
    HOTEL_LOG_babyAgeDetermine: "Độ tuổi trẻ được miễn phí",
    HOTEL_LOG_childAgeDetermine: "Độ tuổi trẻ thêm phụ phí",
    HOTEL_LOG_electronicVoltage: "Điện áp sử dụng",
    HOTEL_LOG_distanceToAirport: "Khoảng cách tới sân bay",
    HOTEL_LOG_serviceTaxPercent: "Mức % thuế dịch vụ được áp dụng",
    HOTEL_LOG_valueAddedTaxPercent: "Mức % thuế VAT được áp dụng",
    HOTEL_LOG_distanceToCenter: "Khoảng cách tới trung tâm",
    HOTEL_LOG_lat: "Vĩ độ",
    HOTEL_LOG_lng: "Kinh độ",
    HOTEL_LOG_phoneNum: "Số điện thoại liên hệ",
    HOTEL_LOG_hotLine: "Số Hot Line",
    HOTEL_LOG_starRanking: "Hạng sao",
    HOTEL_LOG_website: "Website",
    HOTEL_LOG_addressVi: "Địa chỉ VI",
    HOTEL_LOG_addressEn: "Địa chỉ EN",
    HOTEL_LOG_hotelNameVi: "Tên khách sạn VI",
    HOTEL_LOG_hotelNameEn: "Tên khách sạn EN",
    HOTEL_LOG_hotelTypeVi: "Loại khách sạn VI",
    HOTEL_LOG_hotelTypeEn: "Loại khách sạn EN",
    HOTEL_LOG_cityVi: "Tỉnh/Thành phố VI",
    HOTEL_LOG_countryVi: "Quốc gia VI",
    HOTEL_LOG_locationVi: "Quận/Huyện VI",
    HOTEL_LOG_cityEn: "Tỉnh/Thành phố EN",
    HOTEL_LOG_areaVi: "Khu vực VI",
    HOTEL_LOG_countryEn: "Quốc gia EN",
    HOTEL_LOG_locationEn: "Quận/Huyện EN",
    HOTEL_LOG_areaEn: "Khu vực EN",
    HOTEL_LOG_descriptionVi: "Mô tả VI",
    HOTEL_LOG_descriptionEn: "Mô tả EN",
    HOTEL_LOG_depositType: "Hình thức đặt cọc",
    HOTEL_LOG_cutOfDate: "Đặt cọc trước ngày",
    HOTEL_LOG_paymentDay: "Thanh toán trước số ngày",
    HOTEL_LOG_proNameVi: "Tên khuyến mại VI",
    HOTEL_LOG_proNameEn: "Tên khuyến mại EN",
    HOTEL_LOG_promoType: "Loại",
    HOTEL_LOG_sessionType: "Thời gian ở",
    HOTEL_LOG_discountOrSurcharge: "Mức giảm giá/ phụ phí",
    HOTEL_LOG_orderType: "Áp dụng với",
    HOTEL_LOG_notApplyDates: "Ngày không áp dụng",
    HOTEL_LOG_applyPlans: "Gói áp dụng",
    HOTEL_LOG_applyAgents: "Đối tượng áp dụng",
    HOTEL_LOG_applyLevels: "Cấp đại lý áp dụng",
    HOTEL_LOG_applyDays: "Ngày áp dụng",
    HOTEL_LOG_bookType: "Thời gian đặt",
    HOTEL_LOG_fromDays: "Từ ngày",
    HOTEL_LOG_toDays: "Đến ngày",
    HOTEL_LOG_minOrder: "Số lượng tối thiểu",
    HOTEL_LOG_freeForMinOrder: "Số lượng được miễn phí",
    HOTEL_LOG_percentOrFixed: "Hình thức khuyến mại",
    HOTEL_LOG_startBook: "Từ ngày",
    HOTEL_LOG_endBook: "Đến ngày",
    HOTEL_LOG_objectType: "Đối tượng áp dụng",
    HOTEL_LOG_delete: "Xóa",
    HOTEL_LOG_promotionNameVi: "Tên khuyến mại VI",
    HOTEL_LOG_promotionNameEn: "Tên khuyến mại EN",
    HOTEL_LOG_promotionDesVi: "Mô tả VI",
    HOTEL_LOG_promotionDesEn: "Mô tả EN",
    HOTEL_LOG_code: "Mã yêu cầu",
    HOTEL_LOG_note: "Ghi chú",
    HOTEL_LOG_requestStatus: "Trạng thái yêu cầu",
    HOTEL_LOG_fullName: "Tên đầy đủ",
    HOTEL_LOG_gender: "Giới tính",
    HOTEL_LOG_phoneNumber: "Số điện thoại",
    HOTEL_LOG_position: "Chức vụ",
    HOTEL_LOG_address: "Địa chỉ",
    HOTEL_LOG_maxChildren: "Trẻ em",
    HOTEL_LOG_maxAdults: "Người lớn",
    HOTEL_LOG_totalRoom: "Tổng số phòng",
    HOTEL_LOG_defaultPrice: "Giá ngày thường",
    HOTEL_LOG_weekendPrice: "Giá cuối tuần",
    HOTEL_LOG_roomSize: "Kích thước phòng",
    HOTEL_LOG_numberOfExtraBeds: "Số lượng giường thêm",
    HOTEL_LOG_bedTypeTitleVi: "Tên phòng VI",
    HOTEL_LOG_bedTypeTitleEn: "Tên phòng EN",
    HOTEL_LOG_viewVi: "Hướng nhìn VI",
    HOTEL_LOG_viewEn: "Hướng nhìn EN",
    HOTEL_LOG_bedTypeVi: "Loại giường VI",
    HOTEL_LOG_bedTypeEn: "Loại giường EN",
    HOTEL_LOG_sellAllotment: "Allotment",
    HOTEL_LOG_roomName: "Tên phòng",
    HOTEL_LOG_amenityName: "Tiện ích",
    HOTEL_LOG_id: "Mã",
    HOTEL_LOG_nameVi: "Tên VI",
    HOTEL_LOG_nameEn: "Tên EN",
    HOTEL_LOG_adultsIncluded: "Số người lớn",
    HOTEL_LOG_exAdult: "Giá thêm người lớn",
    HOTEL_LOG_aexType: "Loại người lớn",
    HOTEL_LOG_childrenInclued: "Số trẻ em",
    HOTEL_LOG_exChild: "Giá thêm trẻ em",
    HOTEL_LOG_cexType: "Loại trẻ em",
    HOTEL_LOG_start: "Từ ngày",
    HOTEL_LOG_end: "Đến ngày",
    HOTEL_LOG_sesType: "Thời gian ở",
    HOTEL_LOG_minStay: "Số đêm ở tối thiểu",
    HOTEL_LOG_maxStay: "Số đêm ở tối đa",
    HOTEL_LOG_extraBedPrice: "Giá giường thêm",
    HOTEL_LOG_rooms: "Tên phòng",
    HOTEL_LOG_meals: "Bữa ăn bao gồm",
    HOTEL_LOG_plans: "Tên gói",
    HOTEL_LOG_promotions: "Tên khuyến mại",
    HOTEL_LOG_avatar: "Tên ảnh cá nhân",
    HOTEL_LOG_userName: "Tên đăng nhập",
    HOTEL_LOG_userGroup: "Nhóm người dùng",
    HOTEL_LOG_owner: "Chức vụ",
    HOTEL_LOG_name: "Tên",
    HOTEL_LOG_functions: "Tên chức năng",
    HOTEL_LOG_users: "Tên đăng nhập",
    HOTEL_LOG_description: "Mô tả",
    HOTEL_LOG_enterpriseName: "Tên doanh nghiệp",
    HOTEL_LOG_registeredAddress: "Địa chỉ đăng ký kinh doanh",
    HOTEL_LOG_taxCode: "Mã số thuế",
    HOTEL_LOG_bankAccountNumber: "Số tài khoản ngân hàng",
    HOTEL_LOG_bankAccountName: "Tên chủ tài khoản",
    HOTEL_LOG_bankName: "Tên ngân hàng",
    HOTEL_LOG_bankBranch: "Chi nhánh ngân hàng",
    HOTEL_LOG_representative: "Đại diện pháp luật",
    HOTEL_LOG_signer: "Người ký hợp đồng",
    HOTEL_LOG_area: "Khu vực",
    HOTEL_LOG_location: "Quận/Huyện",
    HOTEL_LOG_city: "Thành phố",
    HOTEL_LOG_country: "Quốc gia",
    HOTEL_LOG_hotline: "Hoteline",
    HOTEL_LOG_images: "Tên ảnh",
    HOTEL_LOG_amenities: "Tên tiện ích",
    HOTEL_LOG_landmark: "Nhóm địa điểm",
    HOTEL_LOG_distance: "Khoảng cách",
    HOTEL_LOG_unit: "Đơn vị tính",
    HOTEL_LOG_hotelChains: "Chuỗi khách sạn",
    HOTEL_LOG_roomId: "Mã phòng",
    HOTEL_LOG_views: "Hướng nhìn",
    HOTEL_LOG_agentId: "Mã đại lý",
    HOTEL_LOG_areas: "Tên vùng lân cận",
    HOTEL_LOG_level: "Cấp đại lý",
    HOTEL_LOG_userGroups: "Tên nhóm người dùng",
    HOTEL_LOG_hotelType: "Kiểu khách sạn",
    HOTEL_LOG_logo: "Logo khách sạn",
    HOTEL_LOG_currency: "Đơn vị tiền tệ",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "Hạn chế",
    OTHER_POLICY: "Chính sách khác",
    IF_CANCELED: "Hủy đặt phòng trong khoảng",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "ngày trước ngày đến",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "giá trị đặt phòng sẽ được tính",
    WILL_BE_CHARGED: "sẽ phải chịu phí",
    WILL_BE_CHARGED_POCUP: "Sẽ phải chịu phí",
    RESERVATIONS: "Đặt trước",
    REQUIES_A_DEPOSIT: "đặt cọc",
    OF_THE_BOOKING_VALUE: "giá trị đặt phòng",
    THE_REMAINING_AMOUNT: "số tiền còn lại cần phải thanh toán trước",
    THE_REMAINING_DAYS: "số tiền còn lại cần phải thanh toán trước khi nhận phòng",
    PAYMENT_WHEN_CHECKIN: "Thanh toán hết trước khi nhận phòng (Miễn phí đặt cọc)",
    PAYMENT_WHEN_CHECKOUT: "Thanh toán hết trước khi trả phòng (Miễn phí đặt cọc)",
    VIEWDETAIL_PHOTO: "Xem thêm ảnh",
    PAYMENT_100: "Thanh toán 100% giá trị đặt phòng",
    CANCEL_100: "Hủy đặt phòng sẽ được tính phí 100% giá trị đặt phòng",
    FREE_DEPOSIT: "miễn phí đặt cọc",
    ARRIVAL_DATE: "khi nhận phòng",
    LEAVING_DATE: "khi trả phòng",
    CHIlDRENTS: "trẻ em",
    CHIlDRENT: "trẻ em",
    ADULTS: "người lớn",
    FREE_CANCEL: "hủy miễn phí",
    CHARGE: "được tính phụ phí",
    CHARGE_AS_ADULTS: "được tính phí như người lớn",
    CHILDREN_BELOW: "Trẻ em dưới",
    CHILDREN_OVER: "Trẻ em trên",
    CHILDREN_FROM: "Trẻ em từ",
    AGES: "tuổi",
    DISCOUNT: "Giảm giá",
    READ_MORE: "Đọc thêm",
    READ_LESS: "Đọc ít hơn",
    PICTURE_FACILITIES: "Hình ảnh & Tiện nghi",
    CAPACITY: "Sức chứa",
    OPTIONS: "Chính sách giá",
    ALL_CAPACITY: "Xem tất cả tiện nghi",
    UN_ALL_CAPACITY: "Hiển thị ít hơn",
    PAYMENT_BEFORE: "Thanh toán trước",
    NO_PAYMENT_BEFORE: "Không cần thanh toán trước",
    BOOK_WITHIN: "Đặt trong khoảng",
    PAYMENT_100_NOW: "thanh toán 100% giá trị đặt phòng",
    CANCEL_FREE_FROM: "Miễn phí hủy phòng từ",
    TO_H: "đến trước",
    CANCEL_FREE_BEFORE: "Miễn phí hủy phòng trước",
    FROM: "Từ",
    UNTIL: "Cho đến",
    EARLY_CONFIRM: "Xác nhận phòng sớm!",
    SEND_REQUEST_BOOKING: "GỬI YÊU CẦU",
    SEND_REQUEST_CART: "Thêm yêu cầu",
    SEND_REQUEST_NOW: "GỬI YÊU CẦU NGAY",
    AREA_INFO: "Thông tin khu vực",
    CANCELLATION_POLICY: "Chính sách hủy",
    CHILD_AND_BED: "Chính sách trẻ em",
    IF_CANCELED_BEFORE: "Hủy đặt phòng trước",
    THERE_ARE: "Có",
    ROOM_TYPES_WITH: "loại phòng với",
    OPTIONS_DETAIL: "chính sách giá",
    SPECIAL_OFFER: "Khuyến mại đặc biệt",
    HOTEL_POLICY: "Chính sách khách sạn",
    CHECK_AVAILABILITY: "Tìm phòng",
    PRICE_FOR: "Giá cho",
    ONLY: "Chỉ còn",
    NIGHT: "đêm",
    ROOM_LEFT: "phòng trống",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "Giá chưa bao gồm thuế GTGT",
    SERVICE_CHARGE: "phí dịch vụ",
    THE_PRICE_DOES_INCLUDE_VAT: "Bao gồm thuế GTGT",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "Giá chưa bao gồm thuế",
    SERVICE_CHARGE_NOT_TOOL: "phí",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "Bao gồm thuế",
    ADD_ROOM: "Thêm phòng",
    BOOK_NOW: "ĐẶT NGAY",
    AND_SERVICE_CHARGE: "và phí dịch vụ",
    AND_SERVICE_CHARGE_NOT_TOOL: "và phí",
    NO_CHARGE: "Miễn phí",
    ADULTS_BTN_RESULTSEARCH: "Người lớn",
    ABOVE_12_YEARS: "Trên 12 tuổi",
    CHILDRENS_BTN_RESULTSEARCH: "Trẻ em",
    BELLOW_12_YEARS: "Dưới 12 tuổi",
    ROOM: "Phòng",
    HOW_OLD_ARE_THE_CHILDRENT: "Chọn tuổi của trẻ em đi cùng",
    CHECKIN: "Ngày đến",
    CHECKOUT: "Ngày đi",
    T2: "T2",
    T3: "T3",
    T4: "T4",
    T5: "T5",
    T6: "T6",
    T7: "T7",
    T8: "CN",
    TH1: "Tháng 1",
    TH10: "Tháng 10",
    TH11: "Tháng 11",
    TH12: "Tháng 12",
    TH2: "Tháng 2",
    TH3: "Tháng 3",
    TH4: "Tháng 4",
    TH5: "Tháng 5",
    TH6: "Tháng 6",
    TH7: "Tháng 7",
    TH8: "Tháng 8",
    TH9: "Tháng 9",
    MOST_POPULAR: "Tiện nghi phổ biến",
    EVERY_OPTION: "Các tiện nghi khác",
    GIFT_CODE: "Mã giảm giá",
    COPY_THIS_CODE: "Sao chép mã này và dán vào trang thanh toán",
    ENDOW: "Ưu đãi giảm giá",
    APPLY_FOR_MIN_ORDER_FROM: "cho đơn hàng tối thiểu từ",
    APPLY_ON_TOTAL_ROOM_RATE: "áp dụng trên tổng giá trị tiền phòng",
    APPLY_ON_TOTAL_BOOKING: "áp dụng trên tổng giá trị đặt phòng",
    APPLY_ON_TOTAL_SERVICE: "Áp dụng trên tổng giá trị tiền dịch vụ",
    APPLY_ALL_ORDER: "cho mọi đơn hàng",
    NO_ROOM_LEFT: "Hết phòng trống",
    QUIT_FAVORITE: "Đã thêm vào yêu thích",
    SUM_PROMOTION: "Cộng gộp khuyến mại",
    PRIORITY_PROMOTION: "Khuyến mại ưu tiên",
    BEST_PROMOTION: "Khuyến mại tốt nhất",
    TYPE_PROMOTION: "Kiểu áp dụng khuyến mại",
    INDEX: "Thứ tự",
    PMS_SUCCESS: 'Chúc mừng khách sạn đã hoàn tất để bán phòng trên OneInventory',
    COMPLETE_INFOMATION: "Hoàn thiện thông tin",
    SERVICE: {
        CONFIRM_DEACTIVE_SERVICE: "Bạn có muốn ngừng hoạt động dịch vụ này không ?",
        CONFIRM_DELETE_SERVICE: "Bạn có muốn xoá dịch vụ này không ?",
        SPECIAL_PRICE: "Giá ngày đặc biệt",
        SPECIAL_PRICE_TITLE: "Khoảng ngày giá đặc biệt",
        SPECIAL_PRICE_VALUE: "Giá ngày đặc biệt",
        ADD_SPECIAL_PRICE: "Thêm khoảng ngày",
        HAS_EXITS: "Đã tồn tại",
        LINK: "Danh sách liên kết",
        STATUS_SYNC: "Trạng thái đồng bộ",
        ORDER: "Sắp xếp",
        THUMBNAIL: "Ảnh",
        STATUS: "Trạng thái",
        DEACTIVE: "Ngừng hoạt động",
        ACTIVE: "Đang hoạt động",
        SYNC_PMS: "Đồng bộ từ PMS",
        LIST: "Danh sách dịch vụ",
        INFO: "Thông tin dịch vụ",
        NAME: "Tên dịch vụ",
        DESCRIPTION_INFO: "Mô tả dịch vụ",
        DESCRIPTION_INFO_DEFAULT: "Mô tả mặc định",
        CODE: "Mã dịch vụ",
        TIME_APPLY: "Thời gian áp dụng",
        DAY_APPLY: "Ngày áp dụng trong tuần",
        DAYS_NOT_APPLY: "Khoảng ngày không áp dụng",
        ADD_DAYS_NOT_APPLY: "Thêm khoảng ngày không áp dụng",
        TIME_BOOK: "Thời gian đặt",
        TIME_USE: "Thời gian sử dụng",
        FREE: "Dịch vụ miễn phí",
        PREMIUM: "Dịch vụ có tính phí",
        PRICE: "Giá bán",
        PRICE_STATUS: "Phí dịch vụ",
        INCLUDE_TAX: "Giá đã bao gồm thuế",
        CURRENCY: "Đơn vị tiền tệ",
        COPPY: "Sao chép giá",
        UNIT: "Đơn vị tính",
        PER_BOOKING: "1 đặt phòng",
        PER_PERSON_PER_NIGHT: "1 người 1 ngày",
        PER_ROOM: "1 phòng",
        PER_ROOM_PER_NIGHT: "1 phòng 1 ngày",
        PER_PERSON: "1 người",
        TAX_LABEL: "Thuế/ phí áp dụng",
        MAXBOOK: "Số lượng đặt tối đa",
        PACKAGE_SELL: "chính sách giá áp dụng",
        PACKAGE_ALL: "Áp dụng trên tất cả các chính sách giá",
        PACKAGE_SPEC: "Áp dụng trên các chính sách giá cụ thể",
        SELL_CHANEL: "Kênh bán áp dụng",
        CHANEL_ALL: "Áp dụng trên tất cả các kênh bán",
        CHANEL_SPEC: "Áp dụng trên các kênh bán cụ thể",
        CODE_MAX_LENGTH: "phải lớn hơn 2 ký tự",
        SPECIAL_DESC: "Khai báo giá cho các ngày lễ nếu có chính sách riêng",
        NOT_EMPTY: "không được để trống",
        ERROR_DUPLICATE_DAY: "Khoảng ngày trùng nhau, vui lòng kiểm tra lại",
        TAX_DEFAULT: "Thuế phí mặc định",
        UPDATE_IMAGE_SUCCESS: "Tải ảnh lên thành công",
        UPDATE_IMAGE_FAIL: "Tải ảnh lên thất bại",
        CANCEL: "Huỷ bỏ",
        NOTHUMB: "Ảnh không được để trống",
        IMAGE_TOO_LARGE: "Ảnh có dung lượng tối đa không quá 8MB",
        BINDING_PRICE: "Giá được tính vào tiền phòng",
        MAXQUATITY: "Số lượng dịch vụ tối đa",
        UNLIMIT: "Không giới hạn",
        LIMIT: "Giới hạn",
        ONE_TIME: "Dịch vụ dùng 1 lần",
        CONFIRM_ACTIVE_SERVICE: "Kích hoạt dịch vụ này",
        BENEFIT: "Lợi ích & Tiện ích",
        MANDATORY_ADD_ON: "Dịch vụ đi kèm",
        MANDATORY_ADD_ON_INFO: "Nếu tích chọn dịch vụ đi kèm thì dịch vụ sẽ tự động được thêm vào khi đặt phòng được thiết lập.",
    },
    IMAGE_NOT_EXIST: "Chưa có ảnh",
    IMAGE_SERVICE: "Ảnh dịch vụ",
    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "Loại phòng",
            ROOM_CODE: "Mã loại phòng",
            MAX_PERSON: "Số khách tối đa",
            MAX_ADULT: "Số người lớn tối đa",
            MAX_CHILD: "Số trẻ em tối đa",
            MAX_KID: "Số em bé tối đa",
            ROOM_PARENT_TYPE: "Loại phòng cha",
            ERROR_ROOM_CODE: "Mã loại phòng không được trùng hoặc để trống",
            ERROR_ROOM_PARENT: "Phòng bạn chọn đã được cấu hình là cha của phòng hiện tại"
        },
        EXPAND: "Mở rộng",
        UNEXPAND: "Thu gọn",
        SELL_CHANNEL: "Kênh bán áp dụng",
        SELL_MARKET: "Thị trường áp dụng",
        SELL_CHANNEL_ALL: "Áp dụng trên tất cả các kênh",
        SELL_CHANNEL_SPEC: "Áp dụng trên tất cả các kênh bán cụ thể",
        SELL_MARKET_ALL: "Áp dụng trên tất cả các thị trường",
        SELL_MARKET_SPEC: "Áp dụng trên tất cả các thị trường cụ thể",
        LABEL_SEARCH_CODE_NAME: "Mã/ Tên phòng",
        ENTER_HOTEL_NAME_OR_CODE: "Nhập mã/ tên phòng",
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "Chính sách giá",
        ADD_NEW: "Thêm mới chính sách giá",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "Nhập mã/ tên chính sách giá",
        RATE_CATEGORY: "Danh mục giá",
        RATE_CATEGORY_ADD_NEW: "Thêm mới danh mục giá",
        ROOM_CATEGORY: "Danh mục phòng",
        ROOM_CATEGORY_ADD_NEW: "Thêm mới danh mục phòng"
    },
    ADD_NEW_ROOM: "Thêm mới phòng",
    ROOMS_PER_PAGE: "Số phòng hiển thị trên trang",
    NOT_EMPTY: "Vui lòng nhập dữ liệu",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "Tuổi trẻ em lớn nhất",
        AGE_MAX_BABY: "Tuổi sơ sinh lớn nhất",
        DAY_APPLY_IN_WEEK: "Ngày áp dụng trong tuần",
        PAYMENT_POLICY: "Chính sách thanh toán",
        CANCEL_POLICY: "Chính sách huỷ",
        APPLY_OBJECT: "Nhóm/ Loại chính sách áp dụng",
        APPLY_CARD: "Loại thẻ được áp dụng",
        PACKAGE_CODE: "Mã chính sách giá",
        ADD_PAYMENT_POLICY: "Thêm chính sách thanh toán",
        ADD_CANCEL_POLICY: "Thêm chính sách huỷ",
        SALE_PACKAGE_CODE: "Mã chính sách giá",
        ERROR_SALE_PACKAGE_CODE: "Mã chính sách giá không được trùng hoặc bỏ trống",
    },
    PACKAGE_PER_PAGE: "Số chính sách giá hiển thị trên trang ",
    ADD_RANGE_DAYS_NOT_APPLY: "Thêm khoảng ngày không áp dụng",
    NOT_APPLY_RANGE_DATE: "Khoảng ngày không áp dụng",
    ROOM_AVAILABLE: "Cập nhật phòng trống",
    NO_ROOM_PARENT: "Không chọn phòng cha",
    ROOM_RATE: "Cấu hình giá phòng",
    ADD_SALE_PACKAGE: "Thêm chính sách giá",
    ADD_DATE_RANGE: "Thêm khoảng ngày",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "Xác nhận xoá khoảng ngày này",
    SELECT_SALE_PACKAGE: "Chọn chính sách giá",
    LIST_SALE_PACKAGE_EMPTY: "Không có chính sách giá nào",
    VIEW_TABLE: "Xem dạng bảng",
    VIEW_CALENDAR: "Xem dạng lịch",
    SELECT_ROOM_TO_VIEW: "Vui lòng chọn 1 phòng để xem",
    SHOW_ROOM_AVAIL: "Hiển thị phòng trống",
    ROOM_CONNECTED_OTA: "Phòng đã được đồng bộ OTA",
    RESTRICTION_PACKAGE: "Gói hạn chế",
    RESTRICTION: "Hạn chế",
    ENTER_RESTRICTION_NAME_OR_CODE: "Nhập tên/ mã gói hạn chế",
    CONFIRM_DELETE_RESTRICTION: "Xác nhận xoá gói hạn chế",
    RESTRICTION_INFOMATION: "Thông tin gói hạn chế",
    CONFIG_RESTRICTION: "Cấu hình hạn chế",
    DEFAULT: "Mặc định",
    ROOMTYPE: "Loại phòng",
    ROOMPLAN: "Chính sách giá",
    RESTRICTION_NAME: "Tên gói hạn chế",
    ADD_NEW_RESTRICTION: "Thêm mới hạn chế",
    METADATA: "Chọn cập nhật",
    RESTRICTION_BULK_UPDATE: "Cập nhật hàng loạt",
    RESTRICTION_BULK_DELETE: "Xoá hàng loạt",
    HOTEL_CHAIN: "Chuỗi khách sạn",
    ROOM_AVAIL: "Phòng trống",
    SELL_LIMIT: "Giới hạn bán",
    STOP_SELL_LIMIT: "Giới hạn ngừng bán",
    PRICE: "Giá",
    MANAGE_SYNC_OTA: "Quản lý đồng bộ",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    SUN: "CN",
    MON: "Thứ 2",
    TUE: "Thứ 3",
    WED: "Thứ 4",
    THU: "Thứ 5",
    FRI: "Thứ 6",
    SAT: "Thứ 7",
    ALL_ROOM: "Tất cả phòng",
    NOT_SELECT_SALE_PACKGE: "Chưa chọn chính sách giá",
    DATA_INPUT_INVALID: "Dữ liệu nhập vào không đúng",
    UPDATE: "Cập nhật",
    SELECT_ROOM_APPLY: "Phòng áp dụng",
    SELECT_SALE_PACKAGE_APPLY: "Chính sách giá áp dụng",
    SPECIAL_PRICE: "Giá đặc biệt",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "Giá, chính sách giá không được để trống",
    minStay: "Ngày ở tối thiểu",
    maxStay: "Ngày ở tối đa",
    minStayArrival: "Ngày ở tối thiểu theo ngày đến",
    maxStayArrival: "Ngày ở tối đa theo ngày đến",
    minBookingWindow: "Ngày đặt trước tối thiểu",
    maxBookingWindow: "Ngày đặt trước tối đa",
    minBookingWindowByHour: "Giờ đặt trước tối thiểu",
    maxBookingWindowByHour: "Giờ đặt trước tối đa",
    exactStay: "Ngày ở chính xác",
    exactStayArrival: "Ngày ở chính xác theo ngày đến",
    fromCheckout: "From checkout",
    cutOfTime: "Cut of time",
    closedOnArrival: "Không cho check-in",
    closedOnDeparture: "Không cho check-out",
    closed: "Ngừng bán",
    belongTo: "Belong to",
    appliedFor: "Applied for",
    CHANNEL_APPLY: "Kênh bán áp dụng",
    CHANNEL_EMPTY: "Chưa chọn kênh bán",
    APPLY_FOR: "Áp dụng cho",
    priceExtraAdult: "Phụ thu NL",
    priceExtraChild: "Phụ thu TE",
    priceExtraBaby: "Phụ thu EB",
    DAY_SPECIAL: "Ngày đặc biệt",
    SUN_SHORT: "CN",
    MON_SHORT: "Thứ 2",
    TUE_SHORT: "Thứ 3",
    WED_SHORT: "Thứ 4",
    THU_SHORT: "Thứ 5",
    FRI_SHORT: "Thứ 6",
    SAT_SHORT: "Thứ 7",
    JAN_SHORT: "Tháng 01",
    FEB_SHORT: "Tháng 02",
    MAR_SHORT: "Tháng 03",
    APR_SHORT: "Tháng 04",
    MAY_SHORT: "Tháng 05",
    JUN_SHORT: "Tháng 06",
    JUL_SHORT: "Tháng 07",
    AUG_SHORT: "Tháng 08",
    SEP_SHORT: "Tháng 09",
    OCT_SHORT: "Tháng 10",
    NOV_SHORT: "Tháng 11",
    DEC_SHORT: "Tháng 12",
    NO_SELECT: "Không thay đổi",
    OPEN: "Mở",
    CONFIRM_DELETE_SPECIAL_PRICE: "Xác nhận xóa giá ngày",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "Xác nhận xóa giá đặc biệt phụ thu người lớn",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "Xác nhận xóa giá đặc biệt phụ thu trẻ em",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "Xác nhận xóa giá đặc biệt phụ thu em bé",
    REMOVE_SPECIAL_PRICE: "Xóa giá ngày",
    NO_DATA: "Không có dữ liệu",
    CURRENCY_OTA: "Tiền tệ trên kênh",
    ROOM_TYPE_ON_OTA: "Loại phòng trên OTA",
    SALE_PACKAGE_ON_OTA: "Chính sách giá trên OTA",
    NUMBER_OF_PERSON: "Số lượng người",
    PACKAGE_TYPE: "Loại gói",
    RATES: "Tỷ giá",
    RATES_OSCILLATE: "Giá chênh lệch",
    REGULAR_PRICE: "Giá",
    SYNCED: "Đã đồng bộ",
    ROOM_CLOSED: "Phòng đang đóng",
    NO_SALEPACKAGE_AVAIL: "Không có chính sách giá khả dụng",
    YES: "Có",
    NO: "Không",
    BOOKING_CUSTOMER_NAME: "Tên khách",
    BOOKING_EMPTY: "Không có booking",
    BOOKING_CHANNEL: "Kênh bán",
    BOOKING_HOTEL: "Khách sạn",
    STT: "STT",
    BOOKING_IS_NOT_EXIST: "Đặt phòng không tồn tại",
    ADD_NEW_SALE_CHANNEL: "Thêm mới kênh bán",
    CONNECT: "Kết nối",
    SELECT_SALE_CHANNEL: "Chọn kênh",
    PHONE_INVALID: "Số điện thoại không đúng",
    EMAIL_INVALID: "Email không đúng",
    LOGIN_NOW: "Đăng nhập ngay",
    POLICY_NAME: "Tên chính sách",
    POLICY_DESCRIPTION: "Mô tả chính sách",
    DESCRIPTION: "Mô tả",
    APPLY_DAY: "Tính theo ngày",
    DEPOSIT_UNIT: "Tính theo",
    APPLY_FOR_STAYING: "Tính theo ngày ở",
    APPLY_FOR_BOOKING: "Tính theo ngày đặt",
    CHECKOUT_DATE: "Ngày check-out",
    CHECKIN_DATE: "Ngày check-in",
    BEFORE_CHECKIN_DATE: "Trước ngày nhận phòng",
    BEFORE_CHECKOUT_DATE: "Trước ngày trả phòng",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "Huỷ đặt phòng trước x ngày",
    NIGHT_CAP: "0 đêm | 1 đêm | {count} đêm",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "Yêu cầu đổi pass không còn hiệu lực!",
    MAXROOM_1000: "Số phòng tối đa là 1000",
    DATA_INPUT_MAX_100_PERCENT: "Dữ liệu không được quá 100",
    DATA_INPUT_MAX_10_NIGHT: "Dữ liệu không được quá 10 đêm",
    DUPLICATE_CODE: "Mã bị trùng",
    CREATE: "Tạo mới",
    BULK_UPDATE: "Cập nhật",
    SETUP_OTA: "Thiết lập OTA",
    AUTH: "Truy cập",
    RECEIVE_BOOKING_FROM_OTA: "Nhận Booking từ OTA",
    UPDATE_INVENTORY: "Cập nhật số lượng phòng trống từ PMS",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "Nhận thông tin phòng trống từ PMS",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "Đẩy thông báo booking tới PMS",
    HOTEL_INFO: "Thông tin khách sạn",
    HOTEL_IMAGE: "Hình ảnh khách sạn",
    HOTEL_AREA: "Khu vực khách sạn",
    HOTEL_AMENITY: "Tiện ích khách sạn",
    HOTEL_CANCELLATION_POLICY: "Chính sách hủy đặt phòng",
    HOTEL_SETTING: "Cấu hình khách sạn",
    HOTEL_PAYMENT_POLICY: "Chính sách thanh toán",
    SETUP_AND_MAPPING_TO_OTA: "Thiết lập và ánh xạ tới OTA",
    HOTEL_RATE_PLAN: "Chính sách giá",
    HOTEL_RESTRICTION: "Hạn chế",
    HOTEL_ROOM_TYPE: "Loại phòng",
    HOTEL_ROOM_TYPE_AMENITY: "Tiện ích phòng",
    HOTEL_ROOM_TYPE_AVAILABILITY: "Số phòng bán",
    HOTEL_ROOM_RATE: "Giá phòng",
    HOTEL_ROOM_TYPE_STOP_SELL: "Ngừng bán",
    HOTEL_ROOM_RATE_ADULT: "Cập nhật giá người lớn",
    HOTEL_ROOM_RATE_CHILD: "Cập nhật giá trẻ em",
    HOTEL_ROOM_RATE_BABY: "Cập nhật giá trẻ sơ sinh",
    HOTEL_ROOM_RATE_SPECIAL: "Cập nhật giá ngày đặc biệt",
    STAFF_INFO: "Cập nhật thông tin người dùng",
    STAFF_PASSWORD: "Cập nhật mật khẩu nhân viên khách sạn",
    STAFF_AVATAR: "Cập nhật hình ảnh nhân viên khách sạn",
    STAFF_LOGIN: "Nhân viên khách sạn đăng nhập",
    HOTEL_REGISTER: "Đăng ký khách sạn",
    CHANGE_STATUS: "Đổi trạng thái",
    LOG_ACTION: "Thao tác",
    LOG_FUNCTION: "Chức năng",
    LOG_CONTENT: "Nội dung",
    LOG_DATE_CREATE: "Thời gian",
    LOG_USERNAME: "Tài khoản",
    PRICE_ON_OTA: "Giá bán trên OTA",
    PRICE_ON_DEFINED: "Giá khai báo",
    STOP_SELL_TRIGGER: "Dừng bán theo cấu hình",
    DOWNLOAD: "Tải xuống",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "Chính sách giá đã được đồng bộ OTA, bạn có muốn thay đổi trạng thái ?",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "Loại phòng đã được đồng bộ OTA, bạn có muốn thay đổi trạng thái ?",
    hotel_id: "ID Khách sạn",
    property_id: "Mã khách sạn",
    HOTEL_ROOM_TYPE_IMAGES: "Ảnh phòng",
    IMAGE_MANAGAMENT: "Thư viện ảnh",
    UNIT: "Đơn vị",
    NEARBY_TYPE: "Loại địa điểm lân cận",
    DIALOG_CONFIRM_DESC: "Cập nhật lại hạn chế theo cấu hình của chính sách giá ?",
    CANNOT_GET_INFO_FROM_OTA_1: "Kết nối dữ liệu OTA không thành công.",
    CANNOT_GET_INFO_FROM_OTA_2: "Vui lòng liên hệ 1900 9013 hoặc email: hotro@ezcloud.vn",
    ROOMTYPE_HAS_NO_RATEPLAN: "Vui lòng chọn tổ hợp hạng phòng, chính sách giá và kênh bán đã được thiết lập",
    MAX_LENGTH_10: "Dữ liệu không được quá 10 ký tự",
    UPDATE_BY: "Cập nhật theo",
    OTA_HAS_NO_RATEPLAN: "Chưa có chính sách giá cho ota này",
    PRICE_IS_REQUIRED: "Giá bán không được để trống",
    HOTEL_ROOM_IS_OVER_LIMIT: "Số phòng vượt quá tổng số lượng phòng",
    CONFIRM_DELETE_PROMOTION: "Xác nhận xóa khuyến mại",
    ADD_NEW_PROMOTION: "Thêm mới khuyến mại",
    ADD_NEW_SERVICE: "Thêm mới dịch vụ",
    PRICE_EXTRA: "Giá phụ thu",
    PERSON_NUMBER: "Người thứ",
    DETAIL: "Chi tiết",
    PRICE_AND_PERSON_IS_REQUIRED: "Giá và số người không được để trống",
    CHOOSE_LANG_PAYMENT: "Chọn ngôn ngữ cho phương thức thanh toán",
    ENTER_CONTENT_SHOW: "Nhập nội dung hiển thị",
    CONFIG_BE: "Booking Engine",
    SAVE_SUCCESS: "Lưu thành công",
    CONFIGURE_OUGING_EMAIL: "Email gửi đi",
    EMAIL_SEND: "Địa chỉ email",
    EMAIL_NAME_SEND: "Tên hiển thị",
    SERVER_MAIL_ADDRESS: "Địa chỉ SMTP server",
    CONNECTOR: "Cổng SMTP port",
    ENCRYPTION_TYPE: "Kiểu mã hóa",
    AUTHENTICATON_CONNECTION: "Xác thực kết nối",
    EMAIL_TYPE: "Email gửi đi",
    TEST_EMAIL_SENT: "Test email gửi đi",
    SENT_EMAIL_TEST: "Gửi email test",
    EMAIL_SETTING_EXISTED: "Email đã tồn tại",
    ERROR_MAIL: "Lỗi",
    SUCCESS_MAIL: "Gửi email thành công",
    UNIT_ROOM_PRICE: "Tiền phòng",
    FROM_CHECKOUT: "Tính đến ngày",
    NON_REFUNDABLE: "Trả lại đặt phòng",
    GUEST_NAME: "Tên khách",
    FROM_TIME: "Từ giờ",
    TO_TIME: "Đến giờ",
    PROMOTION_CODE: "Mã khuyến mại",
    SORT: "Sắp xếp",
    HAS_CONNECTED: "Đã thực hiện kết nối",
    GUEST: "Khách",
    PAYMENT_REQUIRED_UPON_BOOKING: "Yêu cầu thanh toán khi đặt phòng",
    CONDITIONS: "Điều kiện",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "Khách thực hiện thanh toán bao nhiêu vào ngày đặt phòng?",
    PERCENT_OF_TOTAL_ROOM_RATE: "% tổng tiền phòng",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "Khách thực hiện thanh toán số tiền còn lại vào thời điểm nào?",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "Chính sách thanh toán được áp dụng trong khoảng thời gian đặt nào?",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "Chính sách thanh toán được áp dụng vào thời gian ở nào?",
    POLICY_SUMMARY: "Tóm tắt chính sách",
    PERCENT_BOOKING: "Phần trăm đặt phòng",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "Khách thực hiện thanh toán khi nào?",
    DATA_INPUT_MAX_24_HOUR: "Dữ liệu không được quá 24 giờ",
    DAY: "Ngày",
    HOUR: "Giờ",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "Khách thực hiện thanh toán bao nhiêu?",
    COUPON_CODE: "Mã coupon",
    ON_THE_DAY_OF_CHECK_IN: "Vào ngày nhận phòng",
    ON_THE_DAY_OF_CHECK_OUT: "Vào ngày trả phòng",
    PRICE_PER_NIGHT: "Giá tiền theo đêm",
    ON_THE_DATE_OF_BOOKING: "Vào ngày đặt phòng",
    UPDATE_PRICE_NOTE: "Dữ liệu giá và số lượng được cập nhật ghi đè. Cập nhật giá bán hạng cơ sở sẽ ảnh hưởng đến giá bán hạng kế thừa",
    PROMOTION_TITLE: "Tên khuyến mại",
    FREE_CANCELLATION_ALLOWED: "Cho phép hủy phòng miễn phí",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "Khách có thể hủy miễn phí trước khi nhận phòng bao lâu?",
    DAY_BEFORE_CHECK_IN: "{day} ngày trước nhận phòng",
    ACCORDING_TO_CUSTOM: "Theo tùy chỉnh",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "Khách phải trả bao nhiêu khi hủy đặt phòng trong vòng {day} ngày trước khi đến?",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "Khách phải trả bao nhiêu khi hủy đặt phòng?",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "Chính sách hủy được áp dụng trong khoảng thời gian đặt nào?",
    WHAT_DOES_CANCEL_POLICY_APPLY: "Chính sách hủy được áp dụng vào thời gian ở nào?",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "Khách hàng sẽ phải trả bao nhiêu nếu khách hủy đặt phòng vào ngày đến?",
    UTC: "Múi giờ",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "Phòng trống từ ít tới nhiều",
    TIME_ZONE_HOTEL: "Múi giờ khách sạn",
    BED_TYPE_SETTING: "Cấu hình loại giường",
    ROOM_TYPE_SETTING: "Cấu hình buồng phòng",
    OVER_MAX_GUEST: "Số khách tối đa trong loại phòng không thỏa mãn",
    OVER_MAX_ADULTS: "Số người lớn tối đa trong loại phòng không thỏa mãn",
    OVER_MAX_CHILDREN: "Số trẻ em tối đa trong loại phòng không thỏa mãn",
    OVER_MAX_BABY: "Số em bé tối đa trong loại phòng không thỏa mãn",
    UNDER_MAX_GUEST: "Số khách tối đa trong chính sách giá không thỏa mãn",
    UNDER_MAX_ADULTS: "Số người lớn tối đa trong chính sách giá không thỏa mãn",
    UNDER_MAX_CHILDREN: "Số trẻ em tối đa trong chính sách giá không thỏa mãn",
    UNDER_MAX_BABY: "Số em bé tối đa trong chính sách giá không thỏa mãn",
    UNDER_MAX_QUANTITY: "Giá trị tổng số phòng không được lớn hơn giá trị phòng trống được khai báo",
    BOOKING_ENGINE: "Công cụ đặt phòng",
    TEXT_NOTIFY_EXPIRED: "Tài khoản kết nối kênh phân phối tới kênh {channel} của quý khách đã hết hạn vào {date}. Các dữ liệu sẽ không được đồng bộ lên kênh OTA, vui lòng thực hiện gia hạn",
    TEXT_NOTIFY_WILL_EXPIRE: "Tài khoản kết nối kênh phân phối tới kênh {channel} của quý khách sẽ hết hạn vào {date}. Các dữ liệu sẽ không được đồng bộ lên kênh OTA, vui lòng thực hiện gia hạn",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "Phòng và chính sách giá trên kênh google hotel",
    HOTEL_LOG_roomTypeI18n: "Loại phòng",
    HOTEL_LOG_lang: "Ngôn ngữ",
    HOTEL_LOG_ratePlanI18n: "Chính sách giá",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "Chưa có kết nối Booking Engine",
    ACCESS_DENIED: "Không có quyền truy cập",
    OTA_NOT_FOUND: "Không tìm thấy OTA",
    HOTEL_SYNC: "Khách sạn đã được đồng bộ",
    PASSWORD_SENT_SUCCESS: "Gửi mật khẩu thành công",
    CAN_NOT_DELETE: "Hạng phòng/Gói bán đã được kết nối với OTA ",
    BOOKING_NOT_CANCEL: "Không thể hủy đặt phòng",
    HEADER_FOOTER_CONFIG: "Giao diện",
    MENU_EDIT: "Chọn loại menu",
    MENU_NAME: "Tên hiển thị",
    MENU_CONFIG: "Menu hiển thị",
    WIDGETS_EDIT: "Chọn loại widget",
    ADD_NEW_WIDGETS: "Thêm mới widget",
    WIDGETS_NOT_YET_DISPLAYED: "Widget chưa hiển thị",
    PARAMETERS: "Thông tin khác",
    LOGO_DISPLAYS: "URL Logo",
    TOP_HEADER_BACKGROUND: "Màu nền Header Top",
    HEADER_BACKGROUND: "Màu nền Header (Màu chính)",
    TEXT_HEADER_COLOR: "Màu chữ Header",
    TEXT_HEADER_COLOR_ACTIVE: "Màu chủ đạo",
    FOOTER_BACKGROUND: "Màu nền Footer",
    TEXT_FOOTER_COLOR: "Màu chữ Footer",
    BACKGROUND_COPYRIGHT: "Màu nền Footer Bottom",
    ADD_NEW_MENU: "Thêm mới menu",
    CONTENT_WIDGETS: "Nội dung",
    TITLE: "Tiêu đề",
    REFERENCE_SAMPLE: "Mẫu tham khảo",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "Lưu kết quả khi thực hiện thay đổi",
    VI: "Tiếng Việt",
    EN: "Tiếng Anh",
    BIGGER_THAN_EQUAL: "lớn hơn hặc bằng",
    AND_MORE: "và {count} lựa chọn khác",
    ALL_AGENT: "Tất cả đại lý",
    GROUP_AGENT: "Nhóm đại lý",
    SPECIFIC_AGENT: "Đại lý cụ thể",
    CHOOSE_NOT_APPLY_AGENT: "Chọn đại lý KHÔNG ÁP DỤNG khuyến mại",
    CHOOSE_APPLY_AGENT: "Chọn đại lý ÁP DỤNG khuyến mại",
    LIST_NOT_APPLY_AGENT: "Danh sách đại lý KHÔNG ÁP DỤNG khuyến mại",
    LIST_APPLY_AGENT: "Danh sách đại lý ÁP DỤNG khuyến mại",
    SEARCH_NAME_AGENT: "Nhập tên hoặc mã đại lý",
    AGENT_TYPE: "Loại hình",
    ENTERPRISE_AGENT: "Công ty du lịch",
    ENTERPRISE_TRADING: "Doanh nghiệp thương mại",
    ENTERPRISE_API: "Đối tác API",
    LIST_AGENT: "Danh sách đại lý",
    SUCCESS: "Thành công",
    CONFIG_CONNECT: "Cấu hình kết nối",
    NO_RECORDS: "Không có bản ghi nào để hiển thị",
    QUANTITY: "Số lượng",
    ROOM_PRICE: "Tổng tiền phòng",
    EXTRA_ADULT: "Người lớn thêm",
    EXTRA_CHILD: "Trẻ em thêm",
    HOTEL_PROMOTION: "Khuyến mãi của khách sạn",
    GUEST_INFO: "Thông tin khách",
    MAX_GUEST: "Số khách",
    MAX: "Tối đa",
    BOOKING_INFO: "Thông tin chung",
    FILE_NULL: "Lỗi tải tệp lên",
    WRONG_DOMAIN: "Tên miền không hợp lệ",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "Vui lòng điền đầy đủ các trường thông tin bắt buộc",
    ADD_NEW_SOCIAL_NETWORK: "Thêm mạng xã hội",
    PRIMARY_TEXT_COLOR: "Màu chữ chính",
    PRIMARY_BACKGROUND_COLOR: "Màu nền chính",
    TOP_HEADER_TEXT_COLOR: "Màu chữ header top",
    TOP_HEADER_BACKGROUND_COLOR: "Màu nền header top",
    HEADER_TEXT_COLOR: "Màu chữ header",
    HEADER_BACKGROUND_COLOR: "Màu nền header",
    FOOTER_TEXT_COLOR: "Màu chữ footer",
    FOOTER_BACKGROUND_COLOR: "Màu nền footer",
    BOTTOM_FOOTER_TEXT_COLOR: "Màu chữ footer bottom",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "Màu nền footer bottom",
    BUTTON_TEXT_COLOR: "Màu chữ button",
    BUTTON_BACKGROUND_COLOR: "Màu nền button",
    BUTTON_TEXT_COLOR_2: "Màu chữ button 2",
    BUTTON_BACKGROUND_COLOR_2: "Màu nền button 2",
    CUSTOM: "Tùy chỉnh",
    URL: "Đường dẫn",
    OTA_IS_OUT_OF_TIME: "Kênh OTA chưa kích hoạt",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "Dữ liệu nhập vào phải lớn hơn 0",
    HOTEL_EXTRA_RATE_UPDATE: "Cập nhật giá phụ thu",
    HOTEL_EXTRA_RATE_DELETE: "Xóa giá phụ thu",
    DATE_OF_STAY_DOES_NOT_APPLY: "Ngày ở không áp dụng",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "Ngày đặt không áp dụng",
    BOOKING_CODE_OTA: "Mã đặt phòng OTA",
    HOTEL_WAS_CONNECTED_WITH_OTA: "Khách sạn đã được kết nối với kênh OTA",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "Đã kết nối",
    NOT_CONNECTED: "Chưa kết nối",
    MISSING_ROOM_AND_PRICE: "Thiếu phòng, giá và hạn chế",
    CONNECTED_OTA: "Ánh xạ OTA",
    SYNC_IN_PROGRESS: "Đang đồng bộ",
    CONNECTING: "Đang kết nối",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "Chưa khai báo phòng và gói giá",
    CONNECTION_FAILED: "Kết nối thất bại",
    SU_CONNECTION: "Kênh bán",
    SU_MAPPING: "Ánh xạ",
    CHANNEL_MANAGER_SYSTEM: "Hệ thống đặt phòng tập trung",
    ENTER_NAME_OR_CODE: "Nhập mã hoặc tên",
    OTA_LOG: "Nhật ký đồng bộ",
    INVENTORY_LOG: "Nhật ký phòng trống",
    ERROR_LOG: "Nhật ký lỗi",
    SOURCE: "Nguồn",
    UPDATE_TIME: "Thời gian cập nhật",
    RATE: "Giá",
    STOP_SELL: "Ngừng bán",
    MIN_STAY: "Ngày ở tối thiểu",
    MAX_STAY: "Ngày ở tối đa",
    EXTRA_ADULT_RATE: "Phụ phí người lớn",
    EXTRA_CHILD_RATE: "Phụ phí trẻ em",
    FULL_UPDATE: "Chi tiết",
    UN_STOP_SELL: "Mở bán",
    OPEN_RESERVATION: "Mở đặt phòng",
    OPEN_CHECKOUT: "Cho trả phòng",
    ACTIVE_LOG: "Nhật ký thao tác",
    ROOM_SALE_UPDATE: "Cập nhật phòng bán",
    PRICE_EXTRA_SPECIAL: "Giá phụ thu đặc biệt",
    WAITING: "Đang thực hiện",
    FAILURE: "Thất bại",
    ERROR_PHONE_NUMBER_LENGTH: "Số điện thoại phải có ít nhất 6 ký tự và tối đa 10 ký tự",
    ERROR_PHONE_NUMBER_STRING: "Số điện thoại không bao gồm chữ và ký tự 0 ở đầu số",
    BASE_PRICE_IS_MISSING: "Chưa khai báo giá cơ sở",
    TOOLTIP_MASTER: "Lựa chọn 1 dòng Master product để làm cơ sở tính giá cho các dòng còn lại",
    ROOM_DERIVE: "Phòng kế thừa - phụ thuộc loại phòng chính",
    DERIVE_OF_ROOM: "Kế thừa phòng",
    COPY_BY_FOMULAR: "Sao chép theo công thức",
    PASTE: "Dán",
    DATE_RANGE: "Khoảng ngày",
    CODE_IS_EXISTED: "Mã dịch vụ đã tồn tại",
    RULE_CODE: "Mã trong khoảng 2-20 ký tự chỉ chứa chữ và số",
    HOTEL_CHANGE_SUCCESS: "Đổi khách sạn thành công",
    ROOM_CLASS: "Loại phòng",
    UPDATE_FOR: "Cập nhật cho {date}",
    UPDATE_RATE_BY_RANGE: "Cập nhật giá theo chặng",
    BOOKER: "Tên người đặt",
    SEARCH_BY_BOOKER: "Tên khách đặt",
    CONTACT_US: "Liên hệ với chúng tôi",
    UPDATE_TO_STOP_SELLING_OPENING: "Cập nhật mở bán/ngừng bán",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "Cập nhật phòng trống theo chặng",
    UPDATE_SELLING_PRICES_IN_STAGES: "Cập nhật giá bán theo chặng",
    UPDATE_STOP_SELL: "Cập nhật giới hạn ngừng bán",
    UPDATE_SELL_LIMIT_BY_OTA: "Cập nhật giới hạn bán",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "Cập nhật giới hạn bán",
    UPDATE_STOP_SELL_BY_OTA: "Cập nhật giới hạn ngừng bán",
    UPDATE_RESTRICTION_STOPSELL: "Cập nhật giới hạn ngừng bán",
    DELETE_SELL_LIMIT_BY_OTA: "Xoá giới hạn bán",
    DELETE_STOP_SELL_BY_OTA: "Xoá giới hạn ngừng bán",
    OTHER_FUNCTION: "Chức năng khác",
    VIEW_MOBILE_VERSION: "Xem dạng mobile",
    VIEW_DESKTOP_VERSION: "Xem dạng máy tính để bàn",
    FILTER_RESULTS: "Lọc kết quả",
    STOPSELL_UPDATE_SUCCESS: "Cập nhật ngùng bán thành công",
    REMOVE_STOPSELL_SUCCESS: "Cập nhật mở bán thành công",
    HOTEL: "0 khách sạn | 1 khách sạn | {count} khách sạn",
    NIGHT_NUMBER: "Số đêm phòng",
    CONFIRM_STOP_SELL: "Xác nhận ngừng bán",
    CONFIRM_REMOVE_STOP_SELL: "Xác nhận mở bán",
    APP: "Ứng dụng",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "Nhập tên ứng dụng bạn muốn tìm kiếm",
    LABEL_NIGHT_BACKGROUND_COLOR: "Màu nền phụ 1",
    LABEL_NIGHT_TEXT_COLOR: "Màu chữ phụ 1",
    PACKAGE_TEXT_COLOR: "Màu chữ chính sách giá",
    PROMOTION_BACKGROUND_COLOR: "Màu nền phụ 2",
    PROMOTION_TEXT_COLOR: "Màu chữ phụ 2",
    PRICE_TEXT_COLOR: "Màu giá tiền 1",
    RANK_STAR_COLOR: "Màu hạng sao",
    TEXT_PRICE_2_COLOR: "Màu giá tiền 2",
    SUB_TEXT_3_COLOR: "Màu chữ phụ 3",
    SUB_BACKGROUND_3_COLOR: "Màu nền phụ 3",
    RE_SYNC: "Repost booking",
    CONFIRM_RE_SYNC: "Xác nhận repost",
    HOTEL_REPORT_BOOKING: "Repost booking",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "1 khoảng thời gian cập nhật không được quá 1 năm",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "Tài khoản chưa được kết nối với ezCms GDS",
    ROOM_TYPE_ON_CMS: "Loại phòng trên ezCrs",
    ROOM_TYPE_ON_SABRE: "Loại phòng trên kênh bán",
    ROOM_PLAN_ON_CMS: "Gói bán trên ezCrs",
    ROOM_PLAN_ON_SABRE: "Gói bán trên kênh bán",
    DISCONNECT: "Ngắt kết nối",
    CONFIRM_DISCONNECT_OTA: "Bạn có chắc chắn muốn ngắt kết nối",
    CONFIRM_CONNECT_OTA: "Bạn có chắc chắn muốn kết nối lại",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: 'Mã phòng không được trùng nhau',
    ROOM_PLAN_DUPLICATE: 'Mã chính sách giá không được trùng nhau',
    YOU_DONT_HAVE_ANY_HOTELS_YET: "Bạn chưa có khách sạn nào.",
    TEXT_GDS_INFOMATION: "GDS là mạng lưới đặt chỗ được điện toán hóa trên toàn thế giới với hơn 450.000 TA sử dụng để đặt phòng khách sạn.",
    CHAIN_CODE: "Mã chuỗi khách sạn",
    CHAIN_TYPE: "Loại chuỗi khách sạn",
    ITEMS_SHOWING: "hạng mục được hiển thị",
    TA_NAME: "Tên đại lý",
    TA_CODE: "Mã đại lý",
    CHAIN_TRAVEL_AGENT_INFOMATION: "Thông tin đại lý",
    ASSIGN_TA_TO_HOTEL: "Gán đại lý vào khách sạn",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "Cho phép ghi đè thông tin xuống khách sạn",
    FIRST_NAME: "Họ",
    LAST_NAME: "Tên",
    CHAIN_AGENT_LIST: "Công ty, đại lý",
    ASSIGN_ROOM_TO_HOTEL: "Gán phòng cho khách sạn",
    ASSIGN_RATE_PLAN_TO_HOTEL: "Gán gói bán chuỗi cho khách sạn",
    CHAIN: "Chuỗi",
    UNASSIGN: "Chưa gán",
    ASSIGN: "Được gán",
    ENTERPRISE_CODE: "Mã số doanh nghiệp",
    FIRST_NAME_REPRESENT: "Họ người đại diện",
    LAST_NAME_REPRESENT: "Tên người đại diện",
    ACCOUNT_HOLDER: "Chủ tài khoản",
    POSITION: "Chức vụ",
    HOTEL_LIST: "Danh sách khách sạn",
    CHAIN_CONFIG: "Cấu hình chuỗi",
    ASSIGN_SERVICE_TO_HOTEL: "Gán dịch vụ cho khách sạn",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "Hạng phòng ở khách sạn đã được kết nối đồng bộ. Vui lòng kiểm tra lại",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "Mã loại phòng trùng với mã loại phòng chuỗi. Vui lòng kiểm tra lại",
    ROOM_CODE_DUPLICATION: "Mã loại phòng đã tồn tại",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "Số lượng phòng vượt quá tổng số lượng phòng ở cấp khách sạn",
    RATE_PLAN_CODE_DUPLICATION: "Đã tồn tại gói bán. Vui lòng kiểm tra lại",
    SERVICE_NOT_EXIST: "Dịch vụ không tồn tại",
    SERVICE_CODE_DUPLICATION: "Mã dịch vụ đã tồn tại ở khách sạn thuộc chuỗi. Vui lòng kiểm tra lại",
    TRAVEL_AGENT_ALREADY_EXIST: "Thông tin công ty, đại lý đã tồn tại. Vui lòng kiểm tra lại",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "Khách sạn được gán sử dụng khác loại tiền tệ, vui lòng kiểm tra lại",
    AUTO_CANCEL: "Cho phép hủy tự động nếu booking không được xác nhận",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "Tài khoản chưa được kết nối với ezCms SiteMinder",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "Tài khoản chưa được kết nối với ezCms Traveloka",
    ROOM_TYPE_MAP_UNMAP: "Loại phòng đang được kết nối sẽ bị ngắt kết nối nếu thực hiện bỏ chọn và lưu. Thao tác này có thể dẫn đến tình trạng mất kết nối, overbooking, unmap booking.",
    OTA_HOTEL_CODE_ALREADY_EXITS: "mã khách sạn bạn điền đã được kết nối, vui lòng kiểm tra lại!",
    INFOMATION_OF_BANK_ACCOUNT: "Thông tin tài khoản ngân hàng",
    ENTIRE_HOTEL: "Toàn bộ khách sạn",
    ACCORDING_TO_EACH_ROOM_CLASS: "Từng hạng phòng",
    NUMBER_OF_ROOMS_AVAILABLE: "Số lượng phòng trống",
    ROOM_OCCUPANCY: "Công suất phòng",
    EDIT_DYNAMIC_PRICING: "Thông tin chi tiết mẫu giá linh hoạt",
    ADD_NEW_DYNAMIC_PRICING: "Thêm mới mẫu giá linh hoạt",
    DYNAMIC_PRICING: "Giá linh hoạt",
    CONFIRM_DELETE_DYNAMIC_PRICING: "Xác nhận xóa mẫu giá linh hoạt",
    DYNAMIC_NAME: "Tên mẫu giá linh hoạt",
    DYNAMIC_DESCRIPTION: "Mô tả mẫu giá linh hoạt",
    CRITERIA: "Tiêu chí",
    PRICE_CALCULATION_FORMULA: "Công thức tính giá",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "Tổng số phòng đã bán của loại phòng (số lượng phòng đã bán của loại phòng bao gồm đặt phòng Day Use)",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "Tổng số phòng đã bán của khách sạn (số lượng phòng đã bán của khách sạn bao gồm đặt phòng Day Use)",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "Tổng số phòng trống của loại phòng",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "Tổng số phòng trống của khách sạn",
    ROOM_CAPACCITY_FORMULA: "Công thức công suất phòng",
    FROM_TO_LESS: "Từ {val} đến nhỏ hơn",
    NO_PRIOTITY: "Không ưu tiên",
    PRIOTITY: "Ưu tiên",
    UN_SELECT_ALL: "Xóa",
    SET_THE_PRICE_CYCLE: "Bán phòng linh hoạt",
    EVENT: "Theo sự kiện",
    CALENDAR: "Theo lịch (Đang phát triển)",
    DYNAMIC_RATE_METHOD: "Phương thức thay đổi giá linh hoạt",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "Xác nhận ngừng kích hoạt giá linh hoạt",
    RMS_MANAGEMENT: "Quản lý doanh thu",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "Không thể tạo quan hệ",
    DERIVED_ROOMTYPE: "Hạng kế thừa",
    BASE: "Hạng cơ sở",
    UPDATE_FORMULAR: "Cập nhật công thức",
    FORMULAR: "Công thức",
    SET_UP_FORMULAR_BY_DATE_RANGE: "Thiết lập công thức theo khoảng ngày",
    MASTER_RATE: "Giá kế thừa",
    SET_UP_FORMULAR: "Thiết lập công thức",
    CONFIRM_DELETE_FORMULA: "Xác nhận xóa công thức",
    EDIT_PRICE: "Sửa giá",
    SETUP_FORMULA: "Cập nhật công thức",
    SETUP_FORMULA_BY_DATE_RANGE: "Cập nhật công thức theo khoảng ngày",
    DELETE_FORMULA: "Xoá công thức",
    CAN_NOT_CREATE: "Không thể tạo bán phòng vì phụ thuộc vào bán phòng cha",
    HAVE_BEEN_CONNECTED_TO_OTA: "Hạng phòng/Gói bán đã được kết nối với OTA",
    CAN_NOT_INACTIVE_OR_DELETE: "Không thể cập nhật",
    ROOM_RATE_IS_CHILDREN: "Hạng cập nhật đang là hạng kế thừa",
    TO_LESS: "đến nhỏ hơn",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "Phương thức thay đổi giá/ cập nhật hạn chế theo sự kiện cho phép khách sạn có thể cấu hình thay đổi theo các sự kiện phát sinh liên quan đến phòng trống bao gồm:",
    CHANGE_TYPE_1: "Phòng trống cập nhật từ PMS",
    CHANGE_TYPE_2: "Booking phát sinh từ các kênh online",
    CHANGE_TYPE_3: "Kích hoạt / Bỏ kích hoạt hạng phòng",
    CHANGE_TYPE_4: "Thiết lập / Chỉnh sửa công thức giá linh hoạt",
    CHANGE_TYPE_5: "Thay đổi giá phòng",
    CHANGE_TYPE_6: "Đóng / Mở phòng",
    SCHEDULE_DYNAMIC_PRICING: "Cấu hình bán phòng linh hoạt",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "Không thể xóa do hạng phòng và gói bán đang cấu hình công thức giá linh hoạt",
    THE_SYSTEM_IS_LOADING: "Hệ thống đang xử lý, vui lòng chờ",
    PAYMENT_CODE: "Mã thanh toán",
    PAYMENT_TYPE: "Loại giao dịch",
    PAYMENT_STATUS: "Trạng thái giao dịch",
    PAYMENT: "Thanh toán",
    REFUND: "Hoàn tiền",
    CANCELLATION_REFUND: "Tiền trả lại",
    CANCELLATION_FEE: "Phí hủy",
    WAITING_PAYMENT: "Chờ xử lý",
    SUCCESS_PAYMENT: "Thành công",
    FAILED: "Thất bại",
    CHAIN_NOT_EXIST: "Chuỗi không tồn tại",
    OTA_HOTEL_NOT_FOUND: "Không tìm thấy OTA",
    CHAIN_INFO: "Thông tin chung - Chuỗi",
    CHAIN_ROOM_TYPE: "Loại phòng - Chuỗi",
    CHAIN_RATE_PLAN: "Chính sách giá - Chuỗi",
    CHAIN_ROOM_TYPE_AMENITY: "Tiện ích phòng - Chuỗi",
    CHAIN_SERVICE: "Dịch vụ - Chuỗi",
    CHAIN_TRAVEL_AGENT: "Thông tin công ty, đại lý - Chuỗi",
    HOTEL_TRAVEL_AGENT: "Thông tin công ty, đại lý",
    BE_MANAGEMENT: "ezBe",
    ADD_SERVICE_TO_ROOM_RATE: "Thêm dịch vụ vào gói bán",
    CONFIRM_DELETE_SERVICE_PACKAGE: "Xác nhận xóa dịch vụ này khỏi gói bán",
    PACKAGE_DEAL: "Gói bán",
    PACKAGE_ITEM: "Dịch vụ gói",
    PRICE_ALLOCATION: "Phân bổ giá",
    WEEKLY_PRICE: "Giá tuần",
    DAILY_PRICE: "Giá ngày",
    RD_DAY: 'Ngày thứ {day}',
    TOTAL_PACKAGE_VALUE: "Tổng giá trị gói",
    LIST_EDIT_SUCCESS: "Cập nhật thành công",
    FOR_EXAMPLE_SERVICE: "Booking từ ngày 1/10 đến ngày 10/10 (9 đêm ở) <br> Với cấu hình tùy chỉnh là: <br> <ul> <li> Bắt đầu từ đêm thứ: 1 </li> <li> Kết thúc vào đêm thứ: Đêm cuối cùng </li> <li>Chu kỳ sử dụng: 2 (ngày)</li> <li> Số lần lặp lại: 3 (lần)</li></ul> Dịch vụ có thể được áp dụng trong các ngày từ 1/10 đến 10/10. <br> Vì chu kỳ sử dụng là 2 (2 ngày/lần) nên dịch vụ có thể được áp dụng vào các ngày 1/10, 3/10, 5/10, 7/10, 9/10.<br> Nhưng do số lần lặp là 3 nên dịch vụ được áp dụng 3 ngày là 1/10, 3/10, 5/10.<br> Với cấu hình trên thì dịch vụ sẽ được áp dụng vào các ngày <strong>1/10, 3/10, 5/10</strong>",
    SCHEDULINGTYPE_1: "Áp dụng đêm lưu trú đầu tiên",
    SCHEDULINGTYPE_2: "Áp dụng đêm lưu trú cuối cùng",
    SCHEDULINGTYPE_3: "X đêm áp dụng 1 lần, bắt đầu từ đêm thứ Y",
    SCHEDULINGTYPE_4: "Áp dụng tất cả các đêm, trừ đêm đầu tiên",
    SCHEDULINGTYPE_5: "Áp dụng tất cả các đêm, trừ đêm cuối cùng",
    SCHEDULINGTYPE_6: "Không áp dụng đêm đầu tiên và đêm cuối cùng",
    SCHEDULINGTYPE_7: "Áp dụng theo các đêm (14 đêm)",
    SCHEDULINGTYPE_8: "Áp dụng X đêm tùy ý",
    SCHEDULINGTYPE_9: "Tùy chỉnh",
    SCHEDULINGTYPE_0: "Tất cả các đêm",
    EXAMPLE: "Ví dụ",
    STARTING_FROMM_NIGHT: "Bắt đầu từ đêm thứ",
    ENDS_ON_NIGHT: "Kết thúc vào đêm thứ",
    USE_CYCLE: "Chu kỳ sử dụng",
    NUMBER_OF_REPETITION: "Số lần lặp lại",
    NUMBER_OF_REPETITION_DETAIL: "Chu kỳ sử dụng (X đêm áp dụng 1 lần)",
    NIGHT_14_DESCRIPTION: "Nếu booking trên 14 đêm thì sau 14 đêm dịch vụ sẽ được áp dụng lặp lại theo chu kỳ chọn",
    CODE_NOT_EMPTY: "Mã không được trùng hoặc để trống",
    BEFORE_THE_LAST_NIGHT: "Trước đêm cuối cùng",
    LAST_NIGHT: "Đêm cuối cùng",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "Giá phân bổ đang lớn hơn tổng giá gói bán. Bạn có xác nhận cập nhật?",
    EDIT_ATTRIBUTION: "Chỉnh sửa phân bổ",
    MIN_ROOM_RATE: "Tiền phòng còn lại tối thiểu",
    COMBO: "Bán gói",
    SERVICE_INCLUDES: "Dịch vụ đi kèm",
    CODE_NOT_VALIDATE: "Mã không hợp lệ",
    ROOM_CLASS_MAPING: "Loại phòng kết nối",
    CONFIRM_SAVE: "Bạn vừa thao tác thay đổi thông tin kết nối. Thao tác này có thể dẫn đến mất kết nối, unmap và overbooking",
    UNDO: "Hoàn tác",
    CONFIRM_UNDO: "Những thay đổi bạn vừa thực hiện sẽ không được lưu, bạn có chắc chắn muốn thực hiện hoàn tác",
    DEFAULT_LANGUAGE: "Ngôn ngữ sử dụng chính",
    RE_SYNC_CONNECT: "Đồng bộ lại",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "Tìm kiếm nâng cao",
    PRICE_OR_OTA_IS_REQUIRED: "Vui lòng không để trống giá bán hoặc kênh bán",
    UPDATE_BY_ROOM_TYPE: "Cập nhật theo loại phòng",
    UPDATE_BY_SALE_PACKAGE: "Cập nhật theo chính sách giá",
    UPDATE_BY_SALE_CHANNEL: "Cập nhật theo kênh bán",
    BULK_DELETE: "Xóa hàng loạt",
    CONFIRM_UPDATE_OVERWRITE: "Xác nhận cập nhật ghi đè giá và số lượng người bao gồm trong giá cho tất cả các kênh bán đã chọn",
    ONLY_UPDATE_PRICE: "Chỉ ghi đè giá",
    DAILY_MASTER_RATE: "Giá ngày kế thừa",
    NUMBER_NIGHT: 'Số đêm',
    NUMBER_ROOM: "Số phòng",
    ROOM_CAP: "0 phòng | 1 phòng | {count} phòng",
    BOOKING_CAP: "0 đặt phòng | 1 đặt phòng | {count} đặt phòng",
    CHECKIN_STATUS_RESERVED: "Đã đặt",
    CHECKIN_STATUS_CHECKIN: "Đã nhận phòng",
    CHECKIN_STATUS_CHECKOUT: "Đã trả phòng",
    CHECKIN_STATUS_NO_SHOW: "Không đến",
    CHECKIN_STATUS_ARRIVAL: "Nhận phòng hôm nay",
    CHECKIN_STATUS_DUE_OUT: "Trả phòng hôm nay",
    CHECKIN_STATUS_CANCELLED: "Đã huỷ",
    NAME_OF_GUEST_STAYING: "Tên khách lưu trú",
    PRICE_EXTRA_DAILY: "Giá phụ thu ngày",
    CHANNEL: "0 kênh | 1 kênh | {count} kênh",
    ASSIGN_RATE_TO_CATEGORY: "Gán chính sách giá cho danh mục",
    _CATEGORY: {
        CODE: "Mã danh mục",
        NAME: "Tên danh mục",
        DESCRIPTION: "Mô tả"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "Gán danh mục cho khách sạn",
    CHAIN_REGIS_INFO: "Thông tin đăng ký chuỗi",
    CONFIRM_DELETE_RATE_CATEGORY: "Xác nhận xóa danh mục giá",
    RATE_CATEGORY_ALREADY_EXIST: "Danh mục giá đã tồn tại",
    RATE_PLAN_DOES_NOT_EXIST: "Chính sách giá không tồn tại",
    CANCEL_REASON: "Lý do hủy",
    RATE_PMS: "Giá bán PMS",
    ALL_PLAN: "Tất cả chính sách giá",
    ALL_RATE_CATEGORY: "Tất cả danh mục giá",
    TO_PAGE: "Danh sách từ 1 đến {count}",
    ASSIGN_ROOM_TYPE: "Gán loại phòng",
    CONFIG_RATE_OTA: "Cấu hình giá OTA",
    CONFIG_RATE_PMS: "Cấu hình giá PMS",
    UPDATE_RATE_PMS: "Cập nhật giá",
    VIEW: "Xem",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "Giá giai đoạn đang chọn sẽ bị xóa ở các loại phòng và gói bán khác. <br>Bạn có chắc chắn muốn xóa giá theo giai đoạn?",
    WAITING_UPDATE: "Dữ liệu đã được ghi nhận và đang trong quá trình xử lý",
    STATUS_ROOM_TYPE_ON_OTA: "Trạng thái kết nối trên OTA",
    BOOKING_LIST_GROUP: "Danh sách đặt phòng đoàn",
    _GROUP_STATUS: {
        HOLD: "Đang giữ phòng",
        TENTATIVE: "Chưa xác nhận",
        CONFIRMED: "Xác nhận",
        CANCELED: "Đã hủy",
        CHECKED_IN: "Đã nhận phòng",
        CHECKED_OUT: "Đã trả phòng",
        CLOSE: "Đã đóng",
        NO_SHOW: "Không đến"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "Tên đặt phòng đoàn",
        BOOKING_GROUP_CODE: "Mã đặt phòng đoàn",
        GROUP_PROFILE_NAME: "Tên hồ sơ đoàn",
        GROUP_PROFILE_CODE: "Mã hồ sơ đoàn",
        BOOKING_GROUP_START_DATE: "Ngày bắt đầu",
        BOOKING_GROUP_END_DATE: "Ngày kết thúc",
        BOOKING_GROUP_CREATE_DATE: "Thời gian tạo",
        STATUS: "Trạng thái đoàn",
    },
    ENTER_TEXT: "Nhập {text}",
    LIST_PROFILE_GROUP: "Danh sách hồ sơ đoàn",
    PROFILE_GROUP: "Hồ sơ đoàn",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "Tìm kiếm theo tên hồ sơ hoặc mã hồ sơ, email, địa chỉ",
    BOOKINGS_GROUP: "Số lượng đặt phòng đoàn",
    PROFILE_NUMBER: "{count} hồ sơ",
    _GROUP: {
        CONFIRM_DELETE: "Xác nhận xóa hồ sơ đoàn",
        DETAIL: "Chi tiết hồ sơ đoàn",
        INFO: "Thông tin hồ sơ",
        INFO_MANAGE: "Thông tin quản lý",
        ASSIGN: "Gán đoàn",
        GROUP_PROFILE_NAME: "Tên hồ sơ",
        GROUP_PROFILE_NAME_OTHER: "Tên khác",
        COMPANY_NAME: "Tên công ty / Đại lý",
        DESCRIPTION: "Mô tả",
        CONTACT_NAME: "Họ và tên người đại diện",
        PHONE_NUMBER: "Số điện thoại",
        PHONE_NUMBER_OTHER: "Số điện thoại khác",
        MANAGE_NAME: "Họ và tên quản lý",
        DETAIL_BOOKING: "Chi tiết đặt phòng đoàn",
        GROUP_INFO: "Thông tin đoàn",
        LEADER: "Trưởng đoàn",
        PMS_CCODE: "Mã PMS",
        CUS_OF_DAYS: "Cut off days",
        CUT_OF_DATE: "Cut off date",
        PAYMENT_INFO: "Thông tin thanh toán",
        TOTAL: "Tổng tiền",
        UPDATE_PROFILE: "Cập nhật hồ sơ đoàn",
        PAYMENT_METHOD: "Hình thức thanh toán",
        PAYMENT_METHOD_BOOKING_RETAIL: "Phương thức thanh toán đặt phòng lẻ",
        BOOKING_GROUP_INFO: "Thông tin đặt phòng đoàn",
        LEADER_NOT_PAY: "Trưởng đoàn không thanh toán",
        LEADER_PAY_ONE_PART: "Trưởng đoàn thanh toán 1 phần",
        LEADER_PAYS_ALL: "Trường đoàn thanh toán toàn bộ",
        CHOOSE_PROFILE: "Chọn hồ sơ đoàn",
        TITLE: "Danh xưng"
    },
    ROOM_OF_LEADER: "Phòng trưởng đoàn",
    NUMBER_OF_BOOKING: "Số lượng đặt phòng",
    SUB_BOOKING_CODE: "Mã đoàn phụ",
    UPDATE_INFO_BOOKING_GROUP: "Cập nhật thông tin hồ sơ booking đoàn",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "Cho phép ghi đè thông tin",
    FILTER: "Bộ lọc",
    GROUP_PROFILE: "Hồ sơ đoàn",
    BOOKING_GROUP_PROFILE: "Đặt phòng đoàn",
    ASSIGN_HOTEL: "Gán khách sạn",
    ASSIGN_ROOM_TO_CATEGORY: "Gán phòng cho danh mục",
    UPDATE_ROOM_RATE_PMS: "Cập nhật giá PMS",
    UPDATE_ROOM_RATE_OTA: "Cập nhật giá OTA",
    BOOKING_UNMAP: "Danh sách đặt phòng chưa gán",
    CONFIRM_DELETE_ROOM_CATEGORY: "Xác nhận xóa danh mục phòng",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "Danh mục phòng chuỗi đã tồn tại",
    ROOM_CATEGORY_ALREADY_EXIST: "Danh mục phòng đã tồn tại",
    ASSIGN_OTA: "Gán kênh bán",
    NOTE_ASIGN_OTA: "Ghi chú: Kênh bán sẽ được mặc định gán vào các hạng phòng được chọn và đồng bộ xuống khách sạn đã đăng ký kênh nếu nhấn lưu",
    ACTION_TIME: "Thời gian thao tác",
    PROCESS_TIME: "Thời gian xử lý",
    IGNORE: "Bỏ qua",
    RESEND: "Cập nhật lại",
    LIST_ACTION_PROCESS: "Danh sách thao tác chưa hoàn thành",
    STATUS_PROCESSING: "Đang xử lý",
    STATUS_FAILED: "Thất bại",
    STATUS_DONE: "Hoàn thành",
    UPDATE_RATE: "Cập nhật giá tuần",
    UPDATE_RATE_SPECIAL: "Cập nhật giá ngày",
    UPDATE_EXTRA_RATE: "Cập nhật phụ thu",
    UPDATE_EXTRA_SPECIAL_RATE: "Cập nhật phụ thu đặc biệt",
    UPDATE_AVAIL: "Cập nhật phòng trống",
    UPDATE_RESTRICTION: "Cập nhật hạn chế",
    PROCESS_CAP: "0 tiến trình | 1 tiến trình | {count} tiến trình",
    CONFIRM_IGNORE: "Thao tác lỗi sẽ không thể thực hiện cập nhật lại. Bạn có chắc chắn muốn chọn bỏ qua",
    HOTEL_BOOKING_UNMAP_REPOST: "Repost booking",
    UPDATE_RESTRICTION_MINSTAY: "Cập nhật minstay",
    UPDATE_RESTRICTION_MAXSTAY: "Cập nhật maxstay",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "Cập nhật minstay arrival",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "Cập nhật maxstay arrival",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "Cập nhật min booking window",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "Cập nhật max booking window",
    UPDATE_RESTRICTION_EXACTSTAY: "Cập nhật exactstay",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "Cập nhật exactstay arrival",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "Cập nhật không cho check in",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "Cập nhật không cho check out",
    UPDATE_RESTRICTION_CLOSED: "Cập nhật ngừng bán",
    DELETE_PRICE_SPECIAL: "Xóa giá ngày",
    DELETE_EXTRA_RATE: "Xóa phụ thu",
    DELETE_EXTRA_SPECIAL_RATE: "xóa phụ thu ngày",
    HOTEL_DASHBOARD_IGNORE_TASK: "Bỏ qua",
    HOTEL_DASHBOARD_REUPDATE_TASK: "Cập nhật lại",
    CHAIN_ROOM_UPDATE_QUANTITY: "Cập nhật số lượng phòng",
    ROOM_UPDATE_QUANTITY: "Cập nhật số lượng phòng",
    CHAIN_ROOM_CATEGORY: "Danh mục phòng - chuỗi",
    HOTEL_ROOM_CATEGORY: "Danh mục phòng",
    HOTEL_RATE_CATEGORY: "Danh mục giá",
    CHAIN_RATE_CATEGORY: "Danh mục giá - chuỗi",
    ERROR_CAUSE: "Nguyên nhân",
    INVENTORY_NOT_SYNC: "Phòng trống không được đồng bộ",
    UNKNOWN_ERROR: "Lỗi không xác định",
    BY_RATE: "Theo giá cố định",
    BY_FORMULA: "Theo công thức",
    CONFIG_TYPE: "Loại cấu hình",
    FOMULA_FROM_TO: "Công thức tính giá từ thứ 2 đến chủ nhật",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "Xác nhận ngừng kích hoạt hạn chế linh hoạt",
    EDIT_DYNAMIC_RESTRICTION: "Thông tin chi tiết mẫu hạn chế linh hoạt",
    ADD_NEW_DYNAMIC_RESTRICTION: "Thêm mới mẫu hạn chế linh hoạt",
    DYNAMIC_RESTRICTION: "Hạn chế linh hoạt",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "Xác nhận xóa mẫu hạn chế linh hoạt",
    DYNAMIC_RESTRICTION_NAME: "Tên mẫu hạn chế linh hoạt",
    DYNAMIC_RESTRICTION_DESCRIPTION: "Mô tả mẫu hạn chế linh hoạt",
    RESTRICTION_CALCULATION_FORMULA: "Thông tin cấu hình",
    NO_CHANGE: "Không thay đổi",
    ADULT_CAP: "0 người lớn | 1 người lớn | {count} người lớn",
    CHILD_CAP: "0 trẻ em | 1 trẻ em | {count} trẻ em",
    BABY_CAP: "0 em bé | 1 em bé | {count} em bé",
    USE_MODEL: "Đặt làm mẫu",
    ADD_RANGE: "Thêm khoảng",
    MODEL_DESCRIPTION_RESTRICTION: "giá/ công thức tính giá/khoảng công suất/hạn chế sẽ được sao chép xuống các loại phòng và gói bán ở dưới nếu chọn.",
    MODEL_DESCRIPTION_PRICE: "giá/ công thức tính giá/khoảng công suất/hạn chế sẽ được sao chép xuống các loại phòng và gói bán ở dưới nếu chọn.",
    NOTE_ROOM_RATE: "B: Giá phòng của loại phòng tương ứng. Giá phòng hiển thị và cập nhật tại màn bán phòng. Khi tạo mới giá phòng được lấy mặc định từ giá phòng ở loại phòng",
    DYNAMIC_SALE: "Bán phòng linh hoạt",
    NOTE_MODEL_PRICE: "Người dùng có thể thao tác chỉnh sửa với các loại phòng được bán sao chép từ mẫu",
    ACCOUNT_UPDATE: "Tài khoản cập nhật",
    ITEMS_PER_PAGE: "Bản ghi trên mỗi trang",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "Cập nhật giá từ chuỗi",
    EQUIVALENT_TO_ROOM_NIGHT: "Đêm phòng tương đương",
    CREATED_BY_ACCOUNT: "Tài khoản tạo",
    IS_LEGACY_ROOM_CLASS: "Không thể xóa do hạng phòng đang là hạng kế thừa",
    ASSIGN_RATE_CATEGORY: "Gán danh mục giá",
    ASSIGN_ROOM_CATEGORY: "Gán danh mục phòng",
    CUSTOMER_PHONE: "Số điện thoại khách đặt",
    CUSTOMER_MAIL: "Email khách đặt",
    DU_DESCRIPTION_OF_ROOM_TYPE: "Đặt Phòng Day Use của loại phòng (Các đặt phòng có ngày đến = ngày đi)",
    DU_DESCRIPTION_OF_HOTEL: "Đặt Phòng Day Use của khách sạn (Các phòng có ngày đến = ngày đi)",
    OVERVIEW: "Tổng quan",
    INDEX_P: "Công suất (P)",
    INDEX_P_ROOM: "Công suất theo loại phòng",
    INDEX_P_HOTEL: "Công suất theo khách sạn",
    INDEX_A: "Số lượng phòng đã bán (bao gồm Day Use) (A)",
    INDEX_B: "Số lượng phòng có thể bán (B)",
    INDEX_DU: "Số lượng phòng đã bán (Day Use) (DU)",
    INDEX_INV: "Phòng trống",
    BY_ROOM: "Tính theo loại phòng",
    BY_HOTEL: "Tính theo toàn bộ khách sạn",
    DYNAMIC_NAME_HAS_EXIST: "Tên linh hoạt đã tồn tại",
    ROOM_SALE_WITH_ROOM_TYPE: "Bán phòng theo loại phòng",
    ROOM_SALE_WITH_OTA: "Bán phòng theo kênh",
    ROOM_FUND: "Quỹ phòng",
    SHOW_CARD_PAYMENT_INFO: "Quản lý thông tin thẻ thanh toán",
    CHOOSE_MARKET_SEGMENT: "Chọn phân khúc thị trường",
    MARKET_SEGMENT: "Phân khúc thị trường",
    NODATA_2: "Vui lòng nhập nhiều hơn 2 ký tự để tìm kiếm",
    ENTER_TO_SEARCH_MORE: "Nhập để tìm kiếm nhiều hơn",
    EMAIL_ACCESSTOKEN: "Email nhận mã truy cập thông tin thẻ",
    TRAVEL_AGENT_SPEC: "Đại lý cụ thể",
    SEGMENT_SPEC: "Phân khúc thị trường cụ thể",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "Chức năng {channel} của quý khách đã hết hạn vào {date}",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "Chức năng {channel} của quý khách sẽ hết hạn vào {date}",
    PLEASE_RENEW: ".  Vui lòng liên hệ qua email <u>hotro@ezcloud.vn</u> hoặc hotline <u>1900 9013</u> để được hỗ trợ.",
    NOTIFY_OFF_MODULE: "Chức năng Bán phòng theo loại phòng sẽ dừng hoạt động trong thời gian tới. Mọi góp ý của quý khách xin gửi về hòm thư <b>hotro@ezcloud.vn</b>",
    NEW_MESSAGE: "Tin nhắn mới",
    PAXONE: "Giá 1 người",
    PAXTOW: "Giá 2 người",
    PAXEXTRA: "Giá mỗi người thêm",
    MAP_PRODUCT: "Gán product",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "Cập nhật hạn chế",
    CREATE_RESTRICTION: "Tạo mới hạn chế",
    DELETE_ROOM_RATE: "Xóa giá phòng",
    UPDATE_SPECIAL_RATE: "Cập nhật giá ngày",
    HERE: "Tại đây",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "Vui lòng bổ sung email nhận thông tin thẻ",
    ADD_PROGRAM: "Thêm chương trình",
    TYPE_APPLY_PROMOTION: "Hệ thống khuyến mại",
    PROMOTION_CHARCE_COUPON: "Khuyến mại, mã giảm giá",
    PROMOTION_CHARGE: "Khuyến mại áp dụng",
    COUPON_APPLY: "Mã giảm giá áp dụng",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "Hệ thống ezPromotion không hỗ trợ loại hình khuyến mại này",
    ERROR_EZ_PROMOTION: "Không thể kết nối với hệ thống ezPromoion",
    CANCEL_PROMOTION_ERROR: "Hủy khuyến mại thất bại",
    CONFIRM_PROMOTION_ERROR: "Xác nhận khuyến mại thất bại",
    RELOAD: "Làm mới",
    WARNING: "Cảnh báo",
    TXT_WARNING_OVER: "Để đảm bảo hiệu suất hệ thống, không nên cập nhật quá 50 dòng cho mỗi lần thao tác. Xin cảm ơn!",
    CONFIRM_DELETE_DATA_ENTERED: "Bạn vừa thực hiện thay đổi master product. Bạn có muốn xóa dữ liệu giá vừa nhập?",
    ROOM_STATUS_1: "Đã đặt",
    ROOM_STATUS_2: "Đang ở",
    ROOM_STATUS_3: "Đã trả phòng",
    ROOM_STATUS_4: "Khách không đến",
    ROOM_STATUS_5: "Hủy phòng",
    BOOKING_HISTORY: "Lịch sử đặt phòng",
    BOOKING_STATUS_OTA: "Trạng thái đặt phòng OTA",
    BOOKING_OTA_STATUS_0: "New booking",
    BOOKING_OTA_STATUS_1: "Modified booking",
    BOOKING_OTA_STATUS_2: "Cancelled booking",
    BOOKING_OTA_STATUS_3: "Forwarding booking",
    COPY_RATE: "Nhân bản chính sách giá",
    SALE_PACKAGE_CODE_NEW: "Mã chính sách giá mới",
    SELLING_PACKAGE_NEW: "Tên chính sách giá mới",
    DUPLICATE: "Nhân bản",
    SALE_PACKAGE_CODE_OLD: "Mã chính sách giá cũ",
    FAST_UPDATE: "Cập nhật nhanh",
    AUTO_CANCEL_PAYMENT_FAIL: "Cho phép hủy tự động nếu booking thanh toán thất bại, sau",
    EZPAYREF: "Mã tham chiếu",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "Nếu chức năng này được kích hoạt, sau khi đặt phòng chuyển sang trạng thái Thanh toán thất bại một khoảng thời gian được cấu hình, ezCrs sẽ tự động hủy các đặt phòng đó. Thời gian mặc định trong lần đầu tiên cài đặt là 30 phút. Nếu để trống, giá trị được áp dụng là 0 phút. <br> Lưu ý: Thời gian hủy đặt phòng có thể chậm hơn một vài phút tùy thuộc vào đường truyền.",
    TOOLTIP_AUTO_CANCEL: "Với các đặt phòng có áp dụng chính sách yêu cầu trả trước trước vào một ngày cụ thể, khi nhận được thanh toán/ đặt cọc của khách hàng bằng các hình thức ezCrs không thể ghi nhận như tiền mặt hoặc chuyển khoản, khách sạn cần xác nhận đặt phòng đó. Nếu kích hoạt chức năng này, ezCrs sẽ tự động hủy các đặt phòng không được xác nhận của ngày hôm đó. Ngày hủy tự động của các đặt phòng sẽ được thiết lập trong chính sách thanh toán và được áp dụng theo từng chính sách giá.",
    CONFIG_BY: "Thiết lập theo",
    LIST_FORMULAR: "Danh sách công thức",
    ROOM_TYPE_BASE: "Loại phòng cơ sở",
    SALE_PACKAGE_BASE: "Chính sách giá cơ sở",
    SALE_CHANNEL_BASE: "Kênh bán cơ sở",
    ROOM_TYPE_DERIVED: "Loại phòng kế thừa",
    SALE_PACKAGE_DERIVED: "Chính sách giá kế thừa",
    SALE_CHANNEL_DERIVED: "Kênh bán kế thừa",
    HOTEL_LOG_derivationType: "Loại công thức",
    HOTEL_LOG_formulaType: "Loại hình",
    HOTEL_LOG_master: "Hạng master",
    HOTEL_LOG_children: "Hạng child",
    HOTEL_LOG_formula: "Công thức",
    HOTEL_ROOM_TYPE_SPECIAL: "Cập nhật giá phòng",
    UPDATE_ROOM_TYPE: "Cập nhật loại phòng",
    TOOLTIP_BASE_ROOM_TYPE: "Chỉ các gói lưu trú của các loại phòng trong hạng kế thừa có cùng chính sách giá và kênh bán với gói lưu trú của loại phòng {value} sẽ được kế thừa tương ứng theo công thức.",
    TOOLTIP_BASE_RATE_PLAN: "Chỉ các gói lưu trú của các chính sách giá trong hạng kế thừa có cùng loại phòng và kênh bán với gói lưu trú của chính sách giá {value} sẽ được kế thừa tương ứng theo công thức.",
    TOOLTIP_BASE_OTA: "Chỉ các gói lưu trú của các kênh bán trong hạng kế thừa có cùng chính sách giá và loại phòng với gói lưu trú của kênh bán {value} sẽ được kế thừa tương ứng theo công thức.",
    VALUE_AND_PERSON_IS_REQUIRED: "Giá và số người không được để trống",
    PLS_CHOOSE_ONE_SELECT_BOX: "Vui lòng chọn ít nhất 1 ô 'xóa' để cập nhật",
    NOTE_DERIVED: "Dữ liệu công thức kế thừa mới sẽ ghi đè công thức cũ nếu trùng gói lưu trú ở hạng kế thừa hoặc hạng cơ sở",
    ROOM_QUANTITY_PARENT_NOT_SAME: "Vui lòng cập nhật số lượng phòng con bằng số lượng phòng cha để có thể lưu",
    IS_REDIRECTING: "Đang chuyển hướng",
    MAP: "Kết nối",
    SYNC_FROM_PRICELABS: "Lấy dữ liệu từ PriceLabs",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "Xóa phụ thu ngày",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "Cập nhật phụ thu ngày",
    SYNC_DATA_TO_OTA: "Đồng bộ dữ liệu lên OTA",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "Dịch vụ không được kích hoạt",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "Không thể xoá loại phòng đang kết nối OTA",
    ENABLE_SYNC_NOT_UPDATED: `Loại phòng đang được kết nối với kênh OTA, vui lòng thực hiện đúng các bước dưới đây để có thể thao tác thay đổi số lượng người trong phòng do việc thay đổi có thể ảnh hưởng đến kết nối.<br><br>\
    <span class="font-weight-bold">Bước 1:</span> Truy cập Quản lý đồng bộ => chọn ezCms vela+=> chọn tab Ánh xạ OTA và tiến hành ngắt kết nối loại phòng cần thay đổi số lượng người với tất cả các kênh OTA đang kết nối.<br>\
    <span class="font-weight-bold">Bước 2:</span> Chọn tab Kênh bán và tiến hành ngắt kết nối của loại phòng cần thay đổi.<br>\
    <span class="font-weight-bold">Bước 3:</span> Thay đổi số lượng người và tiến hành kết nối lại các kênh OTA.<br><br>\
    <span class="font-weight-bold">Lưu ý:</span> Vui lòng thực hiện theo đúng thứ tự các bước trên để tránh lỗi kết nối dẫn đến thất thoát doanh thu.<br>\
    Xem chi tiết <a href="https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/" target="_blank"><u>tại đây</u></a>`,
    ENABLE_SYNC_NOT_CREATED: `Mã loại phòng đã tồn tại ở khách sạn và không thể được thay đổi số lượng người do đang kết nối với OTA. \
    Vui lòng thực hiện thay đổi mã loại phòng hoặc sửa lại số lượng người trong phòng ở chuỗi hoặc ở khách sạn.`,
    UNDERSELL_LIMIT_TITLE: "Thiết lập giá trị phòng trống cho các kênh để kiểm soát việc bán phòng. Khi số phòng trống trên kênh đó còn lại bằng hoặc thấp hơn giá trị này sẽ kích hoạt ngừng bán.",
    SELL_LIMIT_TITLE: "Thiết lập giới hạn phòng tối đa trên các nhóm kênh để kiểm soát việc bán phòng và tối ưu hoá doanh thu.",
    ROOM_FOR_SALE: "Phòng bán",
    NO_CHANNEL_GROUP: "Vui lòng chọn nhóm kênh cần cập nhật",
    DATA_BLANK: "Dữ liệu không được để trống",
    ROOM_QUANTITY_PARENT_NOT_SAME: "Vui lòng cập nhật số lượng phòng con bằng số lượng phòng cha để có thể lưu",
    VALUE_MUST_BE_LESS_THAN_24H: "Vui lòng nhập giá trị nhỏ hơn 24H",
    N_O: "STT",
    MASTER_ROOM_TYPE: "Loại phòng cơ sở",
    MASTER_RATE_PLAN: "Chính sách giá cơ sở",
    MASTER_CHANNEL: "Kênh bán cơ sở",
    DERIVED_ROOM_TYPE: "Loại phòng kế thừa",
    DERIVED_RATE_PLAN: "Chính sách giá kế thừa",
    DERIVED_CHANNEL: "Kênh bán kế thừa",
    MASTER_PRODUCT: "Gói lưu trú cơ sở",
    FORMULAR_LIST: "Danh sách công thức",
    DERIVED_PRODUCT: "Gói lưu trú kế thừa",
    PRICE_FORMULA: "Công thức giá",
    SELECT_TYPE: "Chọn loại hình",
    SHOW_MORE_FOMULA: "Xem thêm công thức khác",
    SELECT_TYPE_RESTRICTION: "Chọn loại hạn chế áp dụng",
    SETUP_FORMULAR_LIST: "Danh sách công thức được thiết lập",
    APPLY_DATE: "Khoảng ngày áp dụng",
    LIST_FROM: "Danh sách từ",
    TO: "đến",
    IN: "tại",
    NO_TYPE_SELECTED: "Vui lòng chọn giá hoặc loại hạn chế để thiết lập công thức",
    ROOM_TYPE_NOT_MATCH: "Không có công thức được thiết lập do chính sách giá hoặc kênh bán ở gói lưu trú cơ sở và kế thừa không tương ứng. Vui lòng kiểm tra lại hoặc tạo thêm các gói lưu trú tương ứng.",
    SALE_PACKAGE_NOT_MATCH: "Không có công thức được thiết lập do loại phòng hoặc kênh bán ở gói lưu trú cơ sở và kế thừa không tương ứng. Vui lòng kiểm tra lại hoặc tạo thêm các gói lưu trú tương ứng.",
    SALE_CHANNEL_NOT_MATCH: "Không có công thức được thiết lập do Loại phòng hoặc chính sách giá ở gói lưu trú cơ sở và kế thừa không tương ứng. Vui lòng kiểm tra lại hoặc tạo thêm các gói lưu trú tương ứng.",
    CUSTOM_NOT_MATCH: "Không có công thức được thiết lập do gói lưu trú cơ sở và kế thừa không tương thích về loại phòng, chính sách giá hoặc kênh bán.",
    CHANGE: "Thay đổi",
    CURRENT_FORMULA: "Công thức cũ",
    NEW_FORMULA: "Công thức được tạo mới",
    MODIFIED_FORMULA: "Công thức được chỉnh sửa",
    DELETED_FORMULA: "Công thức bị xoá",
    DERIVED: "Kế thừa",
    LIST_FORMULAR_UPDATE: "Danh sách công thức được cập nhật",
    BEFORE: "Trước",
    AFTER: "Sau",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "Công thức không tồn tại",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "Cập nhật giờ đặt trước tối thiểu",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "Cập nhật giờ đặt trước tối đa",
    UPDATE_RESTRICTION_SALEINVENTORY: "Cập nhật phòng bán",
    UPDATE_RESTRICTION_SELLLIMIT: "Cập nhật giới hạn bán",
    NUMBER_OF_DAYS: "Số ngày",
    NUMBER_OF_HOURS: "Số giờ",
    REMOVE_DAYLY_RATE: "Xoá giá ngày",
    ALLOW_CHECKIN: "Cho check-in",
    ALLOW_CHECKOUT: "Cho check-out",
    QUICK_UPDATE: "Loại cập nhật",
    BASE_PRICE_REQUIRED: "Vui lòng khai báo giá cơ sở trước",
    CALENDAR_ROOM: "Lịch phòng",
    DATA_BLANK: "Dữ liệu không được để trống",
    WARNING_EMAIL: "Nhập Email",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "Khoảng giá an toàn",
        PROTECTION_RATE_TOOLTIP: "Khoảng giá an toàn là khoảng giá mà khi người dùng cập nhật giá ở màn bán phòng hệ thống không cho phép lưu nếu giá trị nhập vào nhỏ hơn giá tối thiểu hoặc cao hơn giá tối đa",
        MINIMUM_RATE: "Giá tối thiểu",
        MAXIMUM_RATE: "Giá tối đa",
        MINIMUM_RATE_INVALID: "Giá tối thiểu không được lớn hơn giá tối đa",
        MAXIMUM_RATE_INVALID: "Giá tối đa không được nhỏ hơn giá tối thiểu",
        PROTECTION_RATE_INPUT_INVALID: "Giá nhập không được nhỏ hơn {priceMin} hoặc lớn hơn {priceMax}",
        MINIMUM_RATE_INPUT_INVALID: "Giá nhập không được nhỏ hơn giá tối thiểu cài đặt {priceMin}",
        MAXIMUM_RATE_INPUT_INVALID: "Giá nhập không được lớn hơn giá tối đa đã cài đặt {priceMax}",
    },
    PRICE_OUT_OF_BOUND: "Giá nhập không thuộc khoảng giá an toàn",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "Loại phòng trên kênh bán không được trùng nhau",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "Gói bán trên kênh bán không được trùng nhau",
    PRICE_UPDATE_OUT_OF_BOUND: "Giá bán hiện tại đang không thuộc khoảng giá an toàn",
    INCLUDED_TAX: "Đã bao gồm thuế",
    ACTIVATE: "Kích hoạt",
    NO_RANK: "Chưa xếp hạng",
    ONE_STAR: "1 sao",
    TWO_STAR: "2 sao",
    THREE_STAR: "3 sao",
    FOUR_STAR: "4 sao",
    FIVE_STAR: "5 sao",
    EXAMPLE_INFO: `<p><i><u><span>Ví dụ:</span></u></i></p>
    <p>Khách sạn đang sử dụng đơn vị tiền tệ là: <span>VND</span></p>
    <p>Phòng Deluxe có giá khai báo: <span>900.000</span></p>
    <p>Tỷ giá : <span>0.00005</span></p>
    <p>Giá chênh lệch: <span>0.5</span></p>
    <p>Thì giá bán phòng Deluxe trên các kênh OTA sau khi đồng bộ sẽ là : <span>(900.000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "Free sale allotment by Cut of date",
    ACTIVITY_LOG: "0 bản ghi | 1 bản ghi | {count} bản ghi",
    TIPS: "Mẹo",
    _CONFIGURATION: {
        MENU: "Menu",
        WIDGET: "Widget",
        THEME: "Theme",
        SCRIPT: "Script",
        MENU_HEADER: "Menu Header",
        MENU_FOOTER: "Menu Footer",
        LOGO: "Logo",
        HEADER: "Header",
        BE_CONTENT: "BE Content",
        FOOTER: "Footer",
        FOOTER_BOTTOM: "Footer Bottom",
        FOOTER_RIGHT: "Footer Right",
        WIDGET_FOOTER_RIGHT: "Widget Footer Right",
        WIDGET_FOOTER_BOTTOM: "Widget Footer Bottom",
        WIDGET_SOCIAL_MEDIA_ICON: "Widget: Biểu tượng Mạng xã hội",
        WIDGET_HTML_TEXT: "Widget: Văn bản HTML",
        SCRIPT_WILL_ADD_BODY: "Các tập lệnh sẽ được in trong phần <body>",
        SCRIPT_WILL_ADD_HEAD: "Các tập lệnh sẽ được in trong phần <head>",
        TEMPLATE: "Template",
        BODY: "Body",
        BE_SUPPORT: `<p class="fs-14"><b>CÁCH 1: Tích hợp bằng form tạo sẵn</b></p>
        <p>Chức năng này cho phép bạn tích hợp Booking Engine với website. Cụ thể là hiển thị form đặt phòng của Booking Engine trên website của bạn.</p>
        <img src="/script-BE.png">
        <br>
        <p><b>Bước 1:</b> Sao chép đoạn html mẫu dưới đây, đặt vào vị trí muốn hiển thị form đặt phòng trên website.</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>Bước 2:</b> Sao chép đoạn script mẫu dưới đây, đặt vào footer website (trước thẻ đóng body).</p>
                <p> 1. Trường hợp chưa có jquery trên website </p>
                <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
                &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. Trường hợp đã có jquery trên website (khi xảy ra xung đột script)</p>
                <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt; <br>
                &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
                &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>Bước 3:</b> Tuỳ chỉnh các tham số trong hàm <b>create_booking_form</b> tương thích với website của bạn trước khi lưu lại.</p>
        <p class="mb-1"><b>Trong đó:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : Là mã khách sạn của bạn (bắt buộc).</p>
            <p class="mb-1"><i>.booking-form</i> : Là id (#) hoặc class (.) của vị trí thẻ html được khai báo ở Bước 1 (bắt buộc).</p>
            <p class="mb-1"><i>vi</i> : Mã ngôn ngữ hiển thị (tùy chọn). Hỗ trợ 2 mã:</p>
                <p class="mb-1 ml-5"><i>vi</i> : Tiếng Việt</p>
                <p class="mb-1 ml-5"><i>en</i> : Tiếng Anh</p>
            <p class="mb-1"><i>VND</i> : Mã đơn vị tiền tệ hiển thị tham khảo trên Booking Engine, theo quy chuẩn mã đơn vị tiền tệ quốc tế (tùy chọn).</p>
            <p class="mb-1"><i>horizontal</i>: Kiểu hiển thị form (tùy chỉnh). Hỗ trợ 2 kiểu:</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: Hiển thị kiểu ngang</p>
            <p class="mb-1 ml-5"><i>vertical</i>: Hiển thị kiểu dọc</p>  
            <p class="mb-1"><i>#ffffff</i> : Mã màu chữ nút tìm phòng (tùy chọn).</p>
            <p class="mb-1"><i>#fc5b62</i> : Mã màu nền nút tìm phòng (tùy chọn).</p>
        </div>
        <hr>
        <p class="fs-14"><b>CÁCH 2: Tích hợp bằng đường dẫn truy cập</b></p>
        <p>Gán đường dẫn vào nút hoặc đoạn văn bản liên kết. Sử dụng đường dẫn mẫu dưới đây:</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>Trong đó:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: Mã khách sạn (bắt buộc)</p>
            <p class="mb-1"><i>check_in</i>: Ngày đến, định dạng YYYY-MM-DD  (tùy chọn)</p>
            <p class="mb-1"><i>check_out</i>: Ngày đi, định dạng YYYY-MM-DD (tùy chọn)</p>
            <p class="mb-1"><i>num_of_rooms</i>: Số phòng (tùy chọn)</p>
            <p class="mb-1"><i>num_of_adults</i>: Số người lớn (tùy chọn)</p>
            <p class="mb-1"><i>num_of_children</i>: Số trẻ em (tùy chọn)</p>
            <p class="mb-1"><i>room_code</i>: Mã loại phòng (tùy chọn)</p>
            <p class="mb-1"><i>rate_code</i>: Mã chính sách giá (tùy chọn)</p>
            <p class="mb-1"><i>promo_code</i>: Mã khuyến mãi (tùy chọn)</p>
            <p class="mb-1"><i>lang</i> : Mã ngôn ngữ hiển thị (tùy chọn)</p>
            <p class="mb-1"><i>currency</i> : Mã đơn vị tiền tệ hiển thị (tùy chọn)</p>
        </div>
        <hr>
        <p class="fs-14"><b>CÁCH 3: Tích hợp trực tiếp vào website của khách sạn</b></p>
        <p>Chức năng này cho phép bạn tích hợp Booking Engine với website. Cụ thể là hiển thị danh sách đặt phòng của Booking Engine trên website khách sạn.</p>
        <p class="mb-3">
            <b>Bước 1:</b> Sao chép đoạn html mẫu dưới đây, đặt vào vị trí muốn hiển thị form đặt phòng trên website. <br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>Bước 2:</b> Sao chép đoạn script mẫu dưới đây, đặt vào footer website (trước thẻ đóng body).<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Khách Sạn A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'vi',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>Bước 3:</b> Tuỳ chỉnh các tham số trong hàm <b>window.initBookingForm</b> tương thích với website của khách sạn trước khi lưu lại.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>Trong đó:</b></p>
            <p class="mb-1">
                - <i>hotel</i> : Là danh sách khách sạn. Có thể 1 hoặc nhiều khách sạn, mỗi khách sạn được định nghĩa bằng 1 object (bắt buộc).<br/>
                <span style="padding-left: 12px;"><i>hotelName</i> : Là tên khách sạn.</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i> : Là mã khách sạn.</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i> : Là id (#) hoặc class (.) của vị trí thẻ html được khai báo ở Bước 1 (bắt buộc).
            </p>
            <p class="mb-1">
                - <i>path</i> : Đường dẫn đến trang sẽ hiển thị danh sách phòng. Nếu không nhập đường dẫn thì mặc định sẽ trỏ đến trang của BE <code>https://booking.ezcms.vn</code> (tuỳ chọn).
            </p>
            <p class="mb-1">
                - <i>lang</i> : Ngôn ngữ sẽ hiển thị ở form và ngôn ngữ hiển thị của danh sách phòng. Nếu không cấu hình thì mặc định sẽ là Tiếng Việt (tuỳ chọn).<br/>
                <span style="padding-left: 12px;"><b>Hỗ trợ 7 ngôn ngữ:</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i> : Tiếng Việt</span><br/>
                <span style="padding-left: 12px;"><i>en</i> : Tiếng Anh</span><br/>
                <span style="padding-left: 12px;"><i>ja</i> : Tiếng Nhật</span><br/>
                <span style="padding-left: 12px;"><i>ko</i> : Tiếng Hàn</span><br/>
                <span style="padding-left: 12px;"><i>lo</i> : Tiếng Lào</span><br/>
                <span style="padding-left: 12px;"><i>km</i> : Tiếng Khmer</span><br/>
                <span style="padding-left: 12px;"><i>zh</i> : Tiếng Trung</span><br/>
                <span style="padding-left: 12px;"><b>Lưu ý: </b> Nếu trang Booking Engine không cấu hình ngôn ngữ được chọn ở đây thì mặc định ngôn ngữ hiển thị của danh sách phòng sẽ là Tiếng Anh.</span>
            </p>   
            <p class="mb-1">
                - <i>background</i> : Màu nền của form. Mặc định: #eee (tuỳ chọn).
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>: Màu chữ nút "Tìm phòng". Mặc định: #fff (tuỳ chọn).
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>: Màu nền nút "Tìm phòng". Mặc định: màu đỏ (tuỳ chọn).
            </p>
            <p class="mb-1">
                - <i>textColor</i>: Màu chữ trong form. Mặc định là chữ của browser (tuỳ chọn).
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>Bước 4:</b> Tại trang hiển thị danh sách phòng của khách sạn (được cấu hình ở path của bước 3)
        </p>
        <p class="mb-0">
            Sao chép đoạn html mẫu dưới đây, đặt vào vị trí muốn hiển thị danh sách phòng.<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            Sao chép đoạn script mẫu dưới đây, đặt vào footer website (trước thẻ đóng body).<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>Bước 5:</b> Tuỳ chỉnh các tham số trong hàm <b>window.initBookingEngine</b> trước khi lưu.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>Trong đó:</b></p>
            <p class="mb-1">
                - <i>target</i> : Là id (#) hoặc class (.) của vị trí thẻ html được khai báo ở Bước 4 (bắt buộc).
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i> : Hiển thị icon cuộn lên đầu trang khi thanh cuộn xuống dưới 500px, khi click sẽ cuộn lên đầu trang. Mặc định là false (tuỳ chọn).
            </p>
            <p class="mb-1">
                - <i>marginTop</i> : Tạo khoảng cách với phía trên. Mục đích là tránh để nội dung bị che khuất bởi phần tử cố định phía trên. Ví dụ như website có header cố định (tuỳ chọn).
            </p>
        </div>
        <p style="margin-top: 10px;"><b>Tham khảo trang demo </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">tại đây</a></p>
        `,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} đang có số lượng người lớn vượt mức tối đa là 18 người, nếu bạn thực hiện Kết nối hệ thống có thể xảy ra <span class="font-weight-bold">lỗi kết nối</span> thất bại. Vui lòng kiểm tra lại.`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "Bữa sáng",
            LUNCH: "Bữa trưa",
            DINNER: "Bữa tối",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "Áp dụng cho mỗi đêm",
            TOTAL_BOOKING: "Áp dụng trên tổng giá trị gói bán phòng",
            ORDER_BEFORE: "Đặt trước x ngày trước ngày nhận phòng",
            ORDER_WITHIN: "Đặt trong vòng x ngày trước ngày nhận phòng",
            FREE_QUANTITY: "Đặt số lượng x, được khuyến mãi y",
            FREE_ON_TOTAL_VALUE: "Đặt số lượng x, được khuyến mãi y trên tổng giá trị gói bán phòng",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "Giảm giá",
            SURCHARGE: "Phụ phí",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "Áp dụng theo cấp đại lý",
            BY_AGENT: "Áp dụng riêng cho đại lý",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "Cấp 1",
            LEVEL_2: "Cấp 2",
            LEVEL_3: "Cấp 3",
            LEVEL_4: "Cấp 4",
            LEVEL_5: "Cấp 5",
        }
    },
    UTM_CODE: "UTM Code",
    ZOOM: "Zoom",
    NOTIFICATIONS: "Thông báo",
    AGENTS_CONTRACT: "Hợp đồng đại lý đặt phòng",
    BELONG_AGENT: "Của Đại lý",
    HOTEL_LOG_coupon: "Mã giảm giá",
    CONFIRM_CHANGE_ACTIVE: "Xác nhận thay đổi trạng thái đại lý",
    $vuetify: {
        badge: 'Huy hiệu',
        close: 'Đóng',
        dataIterator: {
            noResultsText: 'Không tìm thấy kết quả nào',
            loadingText: 'Đang tải...'
        },
        dataTable: {
            itemsPerPageText: 'Số hàng mỗi trang:',
            ariaLabel: {
                sortDescending: 'Sắp xếp giảm dần.',
                sortAscending: 'Sắp xếp tăng dần.',
                sortNone: 'Không sắp xếp.',
                activateNone: 'Kích hoạt để bỏ sắp xếp.',
                activateDescending: 'Kích hoạt để sắp xếp giảm dần.',
                activateAscending: 'Kích hoạt để sắp xếp tăng dần.'
            },
            sortBy: 'Sắp xếp'
        },
        dataFooter: {
            itemsPerPageText: 'Số mục mỗi trang:',
            itemsPerPageAll: 'Toàn bộ',
            nextPage: 'Trang tiếp theo',
            prevPage: 'Trang trước',
            firstPage: 'Trang đầu',
            lastPage: 'Trang cuối',
            pageText: '{0}-{1} trên {2}'
        },
        datePicker: {
            itemsSelected: '{0} được chọn',
            nextMonthAriaLabel: 'Tháng sau',
            nextYearAriaLabel: 'Năm sau',
            prevMonthAriaLabel: 'Tháng trước',
            prevYearAriaLabel: 'Năm trước'
        },
        noDataText: 'Không có dữ liệu',
        carousel: {
            prev: 'Ảnh tiếp theo',
            next: 'Ảnh trước',
            ariaLabel: {
                delimiter: 'Carousel slide {0} trên {1}'
            }
        },
        calendar: {
            moreEvents: '{0} nữa'
        },
        input: {
            clear: 'Clear {0}',
            prependAction: '{0} prepended action',
            appendAction: '{0} appended action'
        },
        fileInput: {
            counter: '{0} tệp',
            counterSize: '{0} tệp (tổng cộng {1})'
        },
        timePicker: {
            am: 'SA',
            pm: 'CH'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'Điều hướng phân trang',
                next: 'Trang tiếp theo',
                previous: 'Trang trước',
                page: 'Đến trang {0}',
                currentPage: 'Trang hiện tại, Trang {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: 'Đánh giá {0} trên {1}'
            }
        },
        loading: 'Loading...'
    },
    DAYS_OF_WEEK: {
        SUN: "CN",
        MON: "T2",
        TUE: "T3",
        WED: "T4",
        THU: "T5",
        FRI: "T6",
        SAT: "T7",
    },
    URL_INVALID: "URL không hợp lệ",
    SELECT_ROOM_TYPE: "Chọn loại phòng",
    OTA_CONNECTION_ERROR: "Kết nối thất bại",
    ROOM_RATE_TYPE: "Loại phòng {room} chính sách giá {rate}",
    NOT_MATCH_GUEST_COUNT: "Số lượng người không khớp giữa ezCrs và Traveloka",
    STAFF_MANAGEMENT: "Cấu hình người dùng",
    FUNCTION_MANAGEMENT: "Cấu hình quyền truy cập",
    SETUP_RATE_TYPE: "Cài đặt giá gửi về CM trên kênh",
    INCLUDE_COMMISSION: "Đã bao gồm hoa hồng",
    EXCLUDE_COMMISSION: "Không bao gồm hoa hồng",
    UNDEFINED_COMMISSION: "Không xác định",
    EXTRA_DATA_TO_OTA: "Cài đặt giá gửi về CM trên kênh",
    ROOM_TYPE_SYNCED: "Loại phòng đã được kết nối OTA, vui lòng kiểm tra lại.",
    MANDATORY_LANGUAGE_REQUIRED: "Ngôn ngữ Tiếng Việt và Tiếng Anh là bắt buộc.",
    TOOLTIP_TOGGLE_LANGUAGE: "Khi thay đổi ngôn ngữ hiển thị cần cập nhật thêm các trường đa ngôn ngữ. Ví dụ: tên loại phòng, tên chính sách ...",
    TOOLTIP_INCLUDE_COMMISSION: `
        - Cấu hình <span class="font-weight-bold fs-13">Không bao gồm hoa hồng</span> hệ thống ezCrs sẽ thực hiện tính toán lại tiền phòng cho các đặt phòng do kênh thu tiền nếu có đủ dữ liệu.<br/>
        - Cấu hình <span class="font-weight-bold fs-13">Đã bao gồm hoa hồng</span> hệ thống ezCrs sẽ thực hiện giữ nguyên giá trị tiền phòng do kênh gửi về.<br/>
        - Cấu hình <span class="font-weight-bold fs-13">Không xác định</span> dùng trong trường hợp hệ thống chưa xác định được chính xác giá gửi về đã bao gồm hoa hồng hay chưa, 
        khi đó 2 trường thông tin <span class="font-weight-bold fs-13">Đã bao gồm hoa hồng</span> và <span class="font-weight-bold fs-13">Không bao gồm hoa hồng</span> sẽ được đánh dấu Không xác định`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        - Cấu hình <span class="font-weight-bold fs-13">Đã bao gồm hoa hồng</span> hệ thống ezCrs sẽ thực hiện tính toán lại tiền phòng cho các đặt phòng nếu có đủ dữ liệu.<br/>
        - Cấu hình <span class="font-weight-bold fs-13">Không bao gồm hoa hồng</span> hệ thống ezCrs sẽ thực hiện giữ nguyên giá trị tiền phòng do kênh gửi về.<br/>
        - Cấu hình <span class="font-weight-bold fs-13">Không xác định</span> dùng trong trường hợp hệ thống chưa xác định được chính xác giá gửi về đã bao gồm hoa hồng hay chưa, khi đó 2 trường thông tin Đã bao gồm hoa hồng và Không bao gồm hoa hồng sẽ được đánh dấu Không xác định`,
    INPUT_INVALID: "Vượt quá số lượng tối đa",
    GOOGLE_NOTE: "<strong>Lưu ý:</strong> Theo quy định mới của Google, các khách sạn sử dụng Google Hotel bắt buộc phải cập nhật dữ liệu <strong>thuế và phí</strong>. Hệ thống cần có <strong>ít nhất một loại thuế hoặc phí có giá trị lớn hơn 0</strong> để đảm bảo dữ liệu hợp lệ và tránh phát sinh lỗi.",
    INVOICE_REQUEST: "Yêu cầu xuất hoá đơn",
    COMPANY_NAME_OR_BOOKER: "Tên công ty/Người đặt phòng",
    HIDE_INFORMATION: "(Ẩn thông tin)",
    SHOW_INFORMATION: "(Xem thông tin)",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "Dịch vụ khuyến mãi không hoạt động",
    INCLUDE_COMMISSION_RATE: "Tiền phòng có hoa hồng",
    EXCLUDE_COMMISSION_RATE: "Tiền phòng không hoa hồng",
    COMMISSION_RATE_NOTE: "Chú ý: Dữ liệu giá không bao gồm và đã bao gồm hoa hồng chỉ mang tính chất tham khảo",
    SETUP_RATE_TYPE_NOTE: "Lưu ý: Việc chuyển đổi cấu hình “Cài đặt giá gửi về CM trên kênh” chỉ được thực hiện khi hệ thống có tối thiểu 01 loại phòng đã kết nối thành công với kênh tương ứng.",
};